var _defs, _polygon, _path, _polygon2, _path2, _polygon3, _path3, _rect, _path4, _rect2, _rect3, _path5, _rect4, _path6, _rect5, _rect6, _path7, _rect7, _path8, _rect8, _rect9, _path9, _rect10, _path10, _polygon4, _rect11, _path11, _rect12, _path12, _rect13, _rect14, _path13, _rect15, _path14, _rect16, _rect17, _path15, _rect18, _path16, _rect19, _path17, _rect20, _path18, _rect21, _rect22, _polygon5, _rect23, _polygon6, _rect24, _polygon7, _rect25, _path19, _line, _line2, _polygon8, _g, _path20, _path21, _g2, _ellipse, _path22, _path23, _g3, _rect26, _rect27, _text, _text2, _path24, _rect28, _path25, _rect29, _path26, _rect30, _path27, _rect31, _path28, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _text3, _text4, _path29, _rect47, _path30, _rect48, _path31, _rect49, _path32, _rect50, _path33, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _path34, _path35, _rect64, _rect65, _path36, _rect66, _rect67, _path37, _path38, _path39, _line3, _path40, _rect68, _polygon9, _path41, _rect69, _rect70, _rect71, _path42, _rect72, _path43, _rect73, _path44, _rect74, _path45, _rect75, _path46, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _text5, _text6, _path47, _rect91, _path48, _rect92, _path49, _rect93, _path50, _rect94, _path51, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _path52, _path53, _rect108, _rect109, _path54, _rect110, _rect111, _path55, _path56, _path57, _line4, _path58, _rect112, _polygon10, _path59, _rect113, _rect114, _rect115, _path60, _path61, _rect116, _polygon11, _polygon12, _circle, _path62, _path63, _polygon13, _path64, _path65, _circle2, _path66, _ellipse2, _path67, _circle3, _rect117, _rect118, _line5, _path68, _line6, _path69, _path70, _path71, _path72, _path73, _circle4, _path74, _circle5, _path75, _text7, _path76, _rect119, _path77, _rect120, _path78, _rect121, _path79, _rect122, _path80, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _path81, _path82, _rect136, _polygon14, _polygon15, _circle6, _path83, _path84, _polygon16, _path85, _path86, _circle7, _path87, _ellipse3, _path88, _circle8, _rect137, _rect138, _line7, _path89, _line8, _path90, _rect139, _polygon17, _polygon18, _circle9, _path91, _path92, _polygon19, _path93, _circle10, _path94, _path95, _ellipse4, _path96, _circle11, _rect140, _rect141, _line9, _path97, _line10, _path98, _path99, _path100, _rect142, _polygon20, _polygon21, _circle12, _path101, _path102, _polygon22, _path103, _path104, _circle13, _path105, _ellipse5, _path106, _circle14, _rect143, _rect144, _line11, _path107, _line12, _path108, _path109, _path110, _path111, _rect145, _path112, _rect146, _path113, _rect147, _path114, _rect148, _path115, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _path116, _path117, _rect162, _rect163, _path118, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _path119, _rect170, _rect171, _path120, _path121, _rect172, _rect173, _path122, _path123, _path124, _path125, _path126, _line13, _rect174, _rect175, _path127, _path128, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _path129, _rect182, _rect183, _path130, _path131, _rect184, _rect185, _path132, _path133, _path134, _path135, _path136, _line14, _rect186, _rect187, _path137, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _path138, _rect194, _rect195, _path139, _path140, _rect196, _rect197, _path141, _rect198, _path142, _path143, _path144, _path145, _path146, _rect199, _path147, _rect200, _path148, _rect201, _path149, _rect202, _path150, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _path151, _rect216, _path152, _rect217, _path153, _rect218, _path154, _rect219, _path155, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _path156, _rect233, _path157, _rect234, _path158, _rect235, _path159, _rect236, _path160, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _path161, _rect250, _rect251, _path162, _path163, _path164, _rect252, _path165, _path166, _rect253, _path167, _rect254, _path168, _rect255, _path169, _rect256, _path170, _rect257, _path171, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobilityStationsafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .mobilityStations_after_svg__cls-73,.mobilityStations_after_svg__cls-77,.mobilityStations_after_svg__cls-87,.mobilityStations_after_svg__cls-88,.mobilityStations_after_svg__cls-99{fill:#898989}.mobilityStations_after_svg__cls-3{fill:#343a50}.mobilityStations_after_svg__cls-28,.mobilityStations_after_svg__cls-29,.mobilityStations_after_svg__cls-33,.mobilityStations_after_svg__cls-41,.mobilityStations_after_svg__cls-43,.mobilityStations_after_svg__cls-6,.mobilityStations_after_svg__cls-63{fill:#fff}.mobilityStations_after_svg__cls-6{opacity:.32}.mobilityStations_after_svg__cls-7{fill:#cc825c}.mobilityStations_after_svg__cls-8{fill:#7fc3ca}.mobilityStations_after_svg__cls-105,.mobilityStations_after_svg__cls-106,.mobilityStations_after_svg__cls-109,.mobilityStations_after_svg__cls-110,.mobilityStations_after_svg__cls-13,.mobilityStations_after_svg__cls-16,.mobilityStations_after_svg__cls-27,.mobilityStations_after_svg__cls-34,.mobilityStations_after_svg__cls-35,.mobilityStations_after_svg__cls-36,.mobilityStations_after_svg__cls-37,.mobilityStations_after_svg__cls-38,.mobilityStations_after_svg__cls-39,.mobilityStations_after_svg__cls-40,.mobilityStations_after_svg__cls-42,.mobilityStations_after_svg__cls-43,.mobilityStations_after_svg__cls-44,.mobilityStations_after_svg__cls-45,.mobilityStations_after_svg__cls-47,.mobilityStations_after_svg__cls-48,.mobilityStations_after_svg__cls-50,.mobilityStations_after_svg__cls-51,.mobilityStations_after_svg__cls-52,.mobilityStations_after_svg__cls-55,.mobilityStations_after_svg__cls-60,.mobilityStations_after_svg__cls-62,.mobilityStations_after_svg__cls-63,.mobilityStations_after_svg__cls-66,.mobilityStations_after_svg__cls-68,.mobilityStations_after_svg__cls-69,.mobilityStations_after_svg__cls-8,.mobilityStations_after_svg__cls-95{stroke:#343a50}.mobilityStations_after_svg__cls-105,.mobilityStations_after_svg__cls-106,.mobilityStations_after_svg__cls-109,.mobilityStations_after_svg__cls-110,.mobilityStations_after_svg__cls-16,.mobilityStations_after_svg__cls-27,.mobilityStations_after_svg__cls-34,.mobilityStations_after_svg__cls-35,.mobilityStations_after_svg__cls-36,.mobilityStations_after_svg__cls-37,.mobilityStations_after_svg__cls-38,.mobilityStations_after_svg__cls-39,.mobilityStations_after_svg__cls-40,.mobilityStations_after_svg__cls-42,.mobilityStations_after_svg__cls-43,.mobilityStations_after_svg__cls-44,.mobilityStations_after_svg__cls-45,.mobilityStations_after_svg__cls-47,.mobilityStations_after_svg__cls-48,.mobilityStations_after_svg__cls-49,.mobilityStations_after_svg__cls-50,.mobilityStations_after_svg__cls-51,.mobilityStations_after_svg__cls-52,.mobilityStations_after_svg__cls-55,.mobilityStations_after_svg__cls-60,.mobilityStations_after_svg__cls-61,.mobilityStations_after_svg__cls-62,.mobilityStations_after_svg__cls-63,.mobilityStations_after_svg__cls-66,.mobilityStations_after_svg__cls-67,.mobilityStations_after_svg__cls-68,.mobilityStations_after_svg__cls-72,.mobilityStations_after_svg__cls-73,.mobilityStations_after_svg__cls-77,.mobilityStations_after_svg__cls-79,.mobilityStations_after_svg__cls-8,.mobilityStations_after_svg__cls-83,.mobilityStations_after_svg__cls-84,.mobilityStations_after_svg__cls-86,.mobilityStations_after_svg__cls-87,.mobilityStations_after_svg__cls-88,.mobilityStations_after_svg__cls-90,.mobilityStations_after_svg__cls-91,.mobilityStations_after_svg__cls-93,.mobilityStations_after_svg__cls-95,.mobilityStations_after_svg__cls-96,.mobilityStations_after_svg__cls-97,.mobilityStations_after_svg__cls-99{stroke-miterlimit:10}.mobilityStations_after_svg__cls-105,.mobilityStations_after_svg__cls-106,.mobilityStations_after_svg__cls-109,.mobilityStations_after_svg__cls-110,.mobilityStations_after_svg__cls-16,.mobilityStations_after_svg__cls-27,.mobilityStations_after_svg__cls-34,.mobilityStations_after_svg__cls-35,.mobilityStations_after_svg__cls-36,.mobilityStations_after_svg__cls-37,.mobilityStations_after_svg__cls-38,.mobilityStations_after_svg__cls-40,.mobilityStations_after_svg__cls-42,.mobilityStations_after_svg__cls-43,.mobilityStations_after_svg__cls-44,.mobilityStations_after_svg__cls-45,.mobilityStations_after_svg__cls-55,.mobilityStations_after_svg__cls-8,.mobilityStations_after_svg__cls-87,.mobilityStations_after_svg__cls-90,.mobilityStations_after_svg__cls-91{stroke-width:3px}.mobilityStations_after_svg__cls-9{fill:#eb9a6b}.mobilityStations_after_svg__cls-13,.mobilityStations_after_svg__cls-69{stroke-linejoin:round}.mobilityStations_after_svg__cls-13{stroke-width:3.44px}.mobilityStations_after_svg__cls-13,.mobilityStations_after_svg__cls-22{fill:#dedede}.mobilityStations_after_svg__cls-13,.mobilityStations_after_svg__cls-69{stroke-linecap:round}.mobilityStations_after_svg__cls-16{fill:#3b3b3b}.mobilityStations_after_svg__cls-17{fill:#2cb4c3}.mobilityStations_after_svg__cls-21{mix-blend-mode:multiply}.mobilityStations_after_svg__cls-34{fill:#828282}.mobilityStations_after_svg__cls-27{fill:#065494}.mobilityStations_after_svg__cls-28,.mobilityStations_after_svg__cls-29{font-size:41.22px;font-family:Lato-Regular,Lato}.mobilityStations_after_svg__cls-29{font-size:15.03px}.mobilityStations_after_svg__cls-30{letter-spacing:-.01em}.mobilityStations_after_svg__cls-31,.mobilityStations_after_svg__cls-32{letter-spacing:0}.mobilityStations_after_svg__cls-35{fill:#a81628}.mobilityStations_after_svg__cls-36{fill:#525254}.mobilityStations_after_svg__cls-37{fill:#404040}.mobilityStations_after_svg__cls-38{fill:#ce2232}.mobilityStations_after_svg__cls-39,.mobilityStations_after_svg__cls-49,.mobilityStations_after_svg__cls-61,.mobilityStations_after_svg__cls-67,.mobilityStations_after_svg__cls-84,.mobilityStations_after_svg__cls-97{fill:none}.mobilityStations_after_svg__cls-39{stroke-width:2.47px}.mobilityStations_after_svg__cls-40{fill:#a8a9ad}.mobilityStations_after_svg__cls-41{opacity:.17}.mobilityStations_after_svg__cls-42{fill:#ef6767}.mobilityStations_after_svg__cls-44{fill:#455a77}.mobilityStations_after_svg__cls-45{fill:#6784b3}.mobilityStations_after_svg__cls-46{fill:#adadad}.mobilityStations_after_svg__cls-47,.mobilityStations_after_svg__cls-50,.mobilityStations_after_svg__cls-52,.mobilityStations_after_svg__cls-62,.mobilityStations_after_svg__cls-68{fill:#191919}.mobilityStations_after_svg__cls-47{stroke-width:.82px}.mobilityStations_after_svg__cls-48,.mobilityStations_after_svg__cls-60,.mobilityStations_after_svg__cls-66{fill:#857d7a}.mobilityStations_after_svg__cls-48,.mobilityStations_after_svg__cls-52{stroke-width:2.36px}.mobilityStations_after_svg__cls-49,.mobilityStations_after_svg__cls-61,.mobilityStations_after_svg__cls-67{stroke:#191919}.mobilityStations_after_svg__cls-49{stroke-width:4.71px}.mobilityStations_after_svg__cls-50{stroke-width:1.09px}.mobilityStations_after_svg__cls-51,.mobilityStations_after_svg__cls-69{fill:#46bea9}.mobilityStations_after_svg__cls-51{stroke-width:1.85px}.mobilityStations_after_svg__cls-55{fill:#464655}.mobilityStations_after_svg__cls-58{fill:#595959}.mobilityStations_after_svg__cls-60,.mobilityStations_after_svg__cls-63{stroke-width:.6px}.mobilityStations_after_svg__cls-61{stroke-width:1.19px}.mobilityStations_after_svg__cls-62{stroke-width:.27px}.mobilityStations_after_svg__cls-66{stroke-width:2.19px}.mobilityStations_after_svg__cls-67{stroke-width:4.36px}.mobilityStations_after_svg__cls-68{stroke-width:1.01px}.mobilityStations_after_svg__cls-69{stroke-width:1.85px}.mobilityStations_after_svg__cls-72,.mobilityStations_after_svg__cls-74,.mobilityStations_after_svg__cls-86{fill:#2c3d51}.mobilityStations_after_svg__cls-72,.mobilityStations_after_svg__cls-73,.mobilityStations_after_svg__cls-77,.mobilityStations_after_svg__cls-79,.mobilityStations_after_svg__cls-83,.mobilityStations_after_svg__cls-84,.mobilityStations_after_svg__cls-86,.mobilityStations_after_svg__cls-87,.mobilityStations_after_svg__cls-88,.mobilityStations_after_svg__cls-90,.mobilityStations_after_svg__cls-91,.mobilityStations_after_svg__cls-93,.mobilityStations_after_svg__cls-96,.mobilityStations_after_svg__cls-97,.mobilityStations_after_svg__cls-99{stroke:#2c3d4f}.mobilityStations_after_svg__cls-72,.mobilityStations_after_svg__cls-77,.mobilityStations_after_svg__cls-79,.mobilityStations_after_svg__cls-83{stroke-width:.32px}.mobilityStations_after_svg__cls-73{stroke-width:.57px}.mobilityStations_after_svg__cls-90{fill:#455064}.mobilityStations_after_svg__cls-79,.mobilityStations_after_svg__cls-93,.mobilityStations_after_svg__cls-95{fill:#2d3e50}.mobilityStations_after_svg__cls-83,.mobilityStations_after_svg__cls-96{fill:#2c3d4f}.mobilityStations_after_svg__cls-84{stroke-width:.85px}.mobilityStations_after_svg__cls-86,.mobilityStations_after_svg__cls-93,.mobilityStations_after_svg__cls-95,.mobilityStations_after_svg__cls-96,.mobilityStations_after_svg__cls-99{stroke-width:1.03px}.mobilityStations_after_svg__cls-88{stroke-width:1.85px}.mobilityStations_after_svg__cls-91{fill:#ea384e}.mobilityStations_after_svg__cls-97{stroke-width:2.75px}.mobilityStations_after_svg__cls-105{fill:#141414}.mobilityStations_after_svg__cls-106{fill:#c4c0c0}.mobilityStations_after_svg__cls-109{fill:#0b0b0b}.mobilityStations_after_svg__cls-110{fill:#f57500}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_after_svg__V2-Mobitit\\xE4tsstation_Nachher"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-1.11 1081.27 -2.1 930.9 -1.11 538.3 1259.27 538.72 1256.98 930.9 1259.29 1081.27 -1.11 1081.27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.15 539.57L1258 540l-2.28 390.91L1258 1080H.15l-1-149.11 1-391.32M-2.37 537v2.52l-1 391.33 1 149.13v2.51h1262.94v-2.57l-2.29-149.07 2.25-390.85v-2.54H1258L.15 537z",
    className: "mobilityStations_after_svg__cls-3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9bf5c",
    points: "-1.27 539.25 -1.26 306.51 1257.99 306.51 1259.29 539.37 -1.27 539.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.72 307.79l1.28 230.3L0 538V307.79h1256.7m2.54-2.55H-2.53V540.53H0l1258 .11h2.57v-2.56l-1.28-230.3v-2.54z",
    className: "mobilityStations_after_svg__cls-3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "1258 305.44 0 305.29 0 0 1256.72 0 1258 305.44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.44 60.37c6.08-14.3 21.47-24.51 39.64-24.51 17.95 0 33.22 10 39.46 24a32.9 32.9 0 018-1.1c16.39 0 29.68 11.85 29.68 26.46s-13.22 26.43-29.65 26.43H151.4c-16.39 0-29.68-11.85-29.68-26.46 0-11.48 8.28-21.19 19.72-24.82zM608.31 140.74c10.22-24 36.06-41.16 66.58-41.16 30.14 0 55.8 16.72 66.27 40.27a54.69 54.69 0 0113.49-1.85c27.53 0 49.85 19.9 49.85 44.45s-22.32 44.44-49.85 44.44H625c-27.53 0-49.85-19.9-49.85-44.44.04-19.3 13.91-35.55 33.16-41.71zM447.5 85c-6.62-15.54-23.35-26.64-43.11-26.64-19.51 0-36.12 10.82-42.9 26.07a35.17 35.17 0 00-8.73-1.21c-17.83 0-32.28 12.89-32.28 28.78s14.45 28.77 32.28 28.77h83.91c17.82 0 32.27-12.88 32.27-28.77 0-12.47-8.94-23-21.44-27zM866.7 108.79c5.75-13.49 20.3-23.13 37.42-23.13 16.94 0 31.36 9.39 37.24 22.63a30.81 30.81 0 017.58-1.05c15.47 0 28 11.19 28 25s-12.54 25-28 25h-72.83c-15.48 0-28-11.18-28-25-.02-10.86 7.77-19.99 18.59-23.45z",
    className: "mobilityStations_after_svg__cls-6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 498.6,
    height: 238.45,
    x: 215.75,
    y: 164.34,
    className: "mobilityStations_after_svg__cls-7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M712.9 165.78v235.57H217.19V165.78H712.9m2.89-2.88H214.31v241.33h501.48V162.9z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 111.27,
    height: 181.07,
    x: 583.17,
    y: 182.38,
    className: "mobilityStations_after_svg__cls-8",
    transform: "rotate(-180 638.805 272.915)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.18,
    height: 180.81,
    x: 633.71,
    y: 182.73,
    className: "mobilityStations_after_svg__cls-9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M642.4 184.23V362h-7.19V184.23h7.19m3-3h-13.19V365h13.19V181.23z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 111.71,
    height: 10.18,
    x: 582.95,
    y: 267.82,
    className: "mobilityStations_after_svg__cls-9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M693.16 269.32v7.19H584.45v-7.19h108.71m3-3H581.45v13.19h114.71v-13.19z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 111.27,
    height: 181.07,
    x: 464.05,
    y: 180.87,
    className: "mobilityStations_after_svg__cls-8",
    transform: "rotate(-180 519.685 271.405)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.18,
    height: 180.81,
    x: 514.59,
    y: 181.22,
    className: "mobilityStations_after_svg__cls-9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M523.28 182.72v177.81h-7.19V182.72h7.19m3-3h-13.19v183.81h13.19V179.72z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 111.71,
    height: 10.18,
    x: 463.83,
    y: 266.31,
    className: "mobilityStations_after_svg__cls-9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M574 267.81V275H465.33v-7.19H574m3-3H462.33V278H577v-13.19z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 111.27,
    height: 181.07,
    x: 345.06,
    y: 180.65,
    className: "mobilityStations_after_svg__cls-8",
    transform: "rotate(-180 400.69 271.185)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.18,
    height: 180.81,
    x: 395.6,
    y: 181,
    className: "mobilityStations_after_svg__cls-9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M404.28 182.5v177.81h-7.18V182.5h7.18m3-3H394.1v183.81h13.18V179.5z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 111.71,
    height: 10.18,
    x: 344.84,
    y: 266.09,
    className: "mobilityStations_after_svg__cls-9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M455 267.59v7.19H346.34v-7.19H455m3-3H343.34v13.19H458v-13.19z",
    className: "mobilityStations_after_svg__cls-3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6b4a49",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "-215.11 114.01 160.14 -13.4 715.79 162.9 -214.5 162.9 -215.11 114.01"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 540.51,
    height: 238.69,
    x: -2.52,
    y: 244.48,
    className: "mobilityStations_after_svg__cls-9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M536.67 245.8v236.05H-1.2v-236h537.87m2.64-2.64H-3.84v241.28h543.15V243.16z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 199.18,
    height: 238.33,
    x: 338.64,
    y: 244.66,
    className: "mobilityStations_after_svg__cls-7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M536.31 246.16v235.33H340.14V246.16h196.17m3-3H337.14v241.33h202.17V243.16z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 111.27,
    height: 181.07,
    x: 406.7,
    y: 262.64,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.44,
    transform: "rotate(-180 462.335 353.175)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 9.72,
    height: 180.34,
    x: 457.47,
    y: 263.22,
    className: "mobilityStations_after_svg__cls-9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M465.46 265v176.84h-6.26V265h6.26m3.46-3.47h-13.18V445.3h13.18V261.49z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 111.22,
    height: 9.7,
    x: 406.72,
    y: 348.33,
    className: "mobilityStations_after_svg__cls-9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M516.2 350.07v6.21H408.47v-6.21H516.2m3.49-3.49H405v13.19h114.69v-13.19z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 70.19,
    height: 181.07,
    x: -2.28,
    y: 262.64,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.38,
    transform: "rotate(-180 32.81 353.175)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 10.19,
    height: 180.46,
    x: 7.18,
    y: 262.89,
    className: "mobilityStations_after_svg__cls-9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.87 264.39v177.46h-7.2V264.39h7.2m3-3H5.68v183.45h13.18V261.4z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 70.52,
    height: 10.79,
    x: -2.64,
    y: 347.78,
    className: "mobilityStations_after_svg__cls-9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.68 349v8.39H-1.45V349h68.13m2.4-2.4H-3.84v13.19h72.92v-13.21z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 179.69,
    height: 206.95,
    x: 95.74,
    y: 276.04,
    className: "mobilityStations_after_svg__cls-7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.93 277.54v204H97.24v-204h176.69m3-3H94.24v210h182.69v-210z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 143.21,
    height: 194.2,
    x: 115.21,
    y: 288.79,
    className: "mobilityStations_after_svg__cls-9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.92 290.29v191.2H116.71v-191.2h140.21m3-3H113.71v197.2h146.21v-197.2z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 91.66,
    height: 183.12,
    x: 139.75,
    y: 299.72,
    className: "mobilityStations_after_svg__cls-8",
    transform: "rotate(-180 185.585 391.28)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 90.1,
    height: 2.1,
    x: 140.56,
    y: 336.4,
    className: "mobilityStations_after_svg__cls-9"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "232.16 334.9 139.06 334.9 139.06 340 232.16 340 232.16 334.9 232.16 334.9",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 90.23,
    height: 2.1,
    x: 140.43,
    y: 384.84,
    className: "mobilityStations_after_svg__cls-9"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "232.16 383.34 138.93 383.34 138.93 388.44 232.16 388.44 232.16 383.34 232.16 383.34",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 90.24,
    height: 2.1,
    x: 140.49,
    y: 433.29,
    className: "mobilityStations_after_svg__cls-9"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "232.23 431.79 138.99 431.79 138.99 436.89 232.23 436.89 232.23 431.79 232.23 431.79",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 4.18,
    height: 183.22,
    x: 183.49,
    y: 300.41,
    className: "mobilityStations_after_svg__cls-9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.17 301.91v180.22H185V301.91h1.18m3-3H182v186.22h7.18V298.91z",
    className: "mobilityStations_after_svg__cls-3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 274.13,
    x2: 258.25,
    y1: 276.64,
    y2: 288.55,
    className: "mobilityStations_after_svg__cls-13"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 96.73,
    x2: 115.67,
    y1: 277.18,
    y2: 288.88,
    className: "mobilityStations_after_svg__cls-13"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b4b45",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "-391.58 194.27 -16.34 66.86 539.31 243.16 -390.97 243.16 -391.58 194.27"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_after_svg__Haus"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "1260.32 460.33 1008.76 460.33 1008.76 134.46 1261.66 134.46 1260.32 460.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1262.12 -67.7 1141.46 -67.7 1008.62 134.68 1261.66 134.68 1262.12 -67.7",
    className: "mobilityStations_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_after_svg__Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.41,
    height: 121.41,
    x: 1142.03,
    y: 181.19,
    className: "mobilityStations_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.85 174v135.78h135.78V174zm7.18 7.19h55.88v57.53H1142zm0 121.4v-57.53h55.88v57.53zm121.41 0h-59.2v-57.53h59.2zm0-63.87h-59.2v-57.53h59.2z",
    className: "mobilityStations_after_svg__cls-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_after_svg__Fenster-2",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.41,
    height: 121.41,
    x: 1142.03,
    y: 312.63,
    className: "mobilityStations_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.85 305.44v135.78h135.78V305.44zm7.18 7.19h55.88v57.53H1142zm0 121.4V376.5h55.88V434zm121.41 0h-59.2V376.5h59.2zm0-63.87h-59.2v-57.53h59.2z",
    className: "mobilityStations_after_svg__cls-16"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 125.98,
    height: 216.13,
    x: 882.79,
    y: 244.03,
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "881.63 244.03 1008.76 244.03 1008.76 166.05 1008.31 166.05 881.63 244.03"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_after_svg__Fenster-3",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.31,
    height: 76.31,
    x: 907.62,
    y: 271.63,
    className: "mobilityStations_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.11 267.11v85.34h85.34v-85.34zm4.51 4.52h35.12v36.16h-35.12zm0 76.31v-36.17h35.12v36.17zm76.31 0h-37.2v-36.17h37.2zm0-40.15h-37.2v-36.16h37.2z",
    className: "mobilityStations_after_svg__cls-16"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M753.54 471h-1.46c-9.11 0-16.26-4.7-16.26-10.69 0-4.52 4.23-8.44 10.42-10a8.05 8.05 0 01-2-5.12c0-4.66 4.43-8.66 11-10.11a6.75 6.75 0 01-.12-1.27c0-5.09 5.27-9.35 12.69-10.42.91-5.39 7.68-9.45 16.16-9.45a24.2 24.2 0 013.92.31c3.05-2.67 7.84-4.25 13-4.25a23.22 23.22 0 018.09 1.4 19.4 19.4 0 0111.25-4c3-2.78 7.92-4.43 13.22-4.43 8.55 0 15.37 4.13 16.18 9.59 5.06.92 9.05 3.36 10.81 6.6 7.27.15 13.37 3.36 15.18 7.89 7.22.26 13.19 3.55 14.86 8.12 6.29 1.55 10.45 5.49 10.45 10a8.33 8.33 0 01-2.79 6c4.68 1.92 7.57 5.29 7.57 9.06 0 4.9-5 9.16-12.22 10.35h-.12l-139.05.42h-.78z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M833.48 404.48c8.15 0 14.76 4.11 14.76 9.19a1.23 1.23 0 010 .19c5.57.72 10 3.4 11.31 6.82h.45c7.44 0 13.57 3.43 14.59 7.88h.17c7.45 0 13.59 3.44 14.6 7.91 5.89 1.2 10.14 4.65 10.14 8.72 0 2.58-1.71 4.91-4.46 6.58 5.41 1.36 9.24 4.66 9.24 8.52 0 4.25-4.66 7.82-11 8.87l-139 .32h-2.17c-8.15 0-14.76-4.12-14.76-9.19 0-4.52 5.25-8.27 12.15-9-2.28-1.62-3.68-3.73-3.68-6.06 0-4.35 4.87-8 11.39-8.94a6.05 6.05 0 01-.54-2.43c0-4.62 5.48-8.43 12.6-9.08v-.11c0-5.08 6.61-9.19 14.76-9.19a23.14 23.14 0 014.4.41c2.6-2.61 7.23-4.35 12.53-4.35a21.3 21.3 0 018.39 1.64c2.48-2.42 6.71-4.06 11.59-4.24 2.59-2.63 7.25-4.4 12.58-4.4m0-3c-5.44 0-10.5 1.65-13.83 4.47a21.28 21.28 0 00-10.92 3.74 25.24 25.24 0 00-7.81-1.21c-5.23 0-10.13 1.54-13.45 4.17a25.11 25.11 0 00-3.48-.23c-8.68 0-15.72 4.07-17.38 9.63-7.64 1.42-13 6.13-13 11.75v.12c-6.52 1.84-10.85 6.2-10.85 11.25a9.11 9.11 0 001.07 4.25c-5.8 2-9.54 6.07-9.54 10.85 0 6.83 7.8 12.19 17.76 12.19h1.46a7.39 7.39 0 00.84 0l138.9-.31h.48c8.06-1.34 13.48-6.09 13.48-11.83 0-3.86-2.5-7.33-6.65-9.57a9.4 9.4 0 001.87-5.53c0-5-4.29-9.4-10.86-11.25-2.12-4.55-8-7.8-15-8.31-2.34-4.43-8.27-7.54-15.29-7.91-2-3-5.76-5.35-10.42-6.4-1.57-5.67-8.67-9.82-17.44-9.82z",
    className: "mobilityStations_after_svg__cls-3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "mobilityStations_after_svg__cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.89 440.71c.76.16 1.48.35 2.18.57a10.91 10.91 0 00-3.11-2.7 6.59 6.59 0 01.93 2.13zM881.13 432.82h.16a22.21 22.21 0 016.77 1c-1.81-2.41-5.25-4.25-9.44-5a7.71 7.71 0 012.51 4zM902.19 455.6c-.2.14-.4.28-.62.41.44.11.87.24 1.28.38a9.52 9.52 0 00-.66-.79zM743.9 464.53c0-4.52 5.24-8.26 12.15-9-2.29-1.62-3.69-3.74-3.69-6.06 0-4.36 4.87-8 11.4-8.94a5.9 5.9 0 01-.54-2.44c0-4.61 5.47-8.42 12.59-9.08v-.11c0-5.07 6.61-9.19 14.76-9.19a23.05 23.05 0 014.4.42c2.6-2.61 7.24-4.35 12.53-4.35a21.35 21.35 0 018.4 1.63c2.47-2.41 6.71-4.06 11.58-4.23 2.6-2.64 7.25-4.4 12.58-4.4a22.13 22.13 0 016.79 1c-2.36-3.13-7.45-5.3-13.36-5.3-5.33 0-10 1.77-12.58 4.4-4.88.18-9.11 1.82-11.59 4.24a21.3 21.3 0 00-8.39-1.64c-5.3 0-9.93 1.74-12.53 4.35a23.14 23.14 0 00-4.4-.41c-8.15 0-14.76 4.11-14.76 9.19v.11c-7.12.65-12.6 4.46-12.6 9.08a6.05 6.05 0 00.54 2.43c-6.52.95-11.39 4.59-11.39 8.94 0 2.33 1.4 4.44 3.68 6.06-6.9.77-12.15 4.52-12.15 9 0 3.55 3.24 6.62 8 8.15a6.44 6.44 0 01-1.42-3.85zM866.1 425h.43a21.9 21.9 0 016.77 1c-2-2.68-6-4.66-10.86-5.17a9.21 9.21 0 013.66 4.17zM854.81 417.93v.2a21.17 21.17 0 013.71.83 11.63 11.63 0 00-4.17-3.29 5.9 5.9 0 01.46 2.26z",
    className: "mobilityStations_after_svg__cls-22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "mobilityStations_after_svg__Baum"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 643.29,
    cy: 259.78,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 72.49,
    ry: 73.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "M580.86 261.18c0-40.36 32.45-73.07 72.49-73.07 1.66 0 3.3.06 4.93.17a72.53 72.53 0 00-15-1.57c-40 0-72.49 32.72-72.49 73.07 0 38.68 29.83 70.34 67.56 72.89a73 73 0 01-57.49-71.49z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M633.63 474.49a4.38 4.38 0 01-3.16-1.35 4.21 4.21 0 01-1.17-3.14l11.55-169.57-12.88-13a1.94 1.94 0 012.22-3.1l11.37 5.55 1.65-24.2.11-2a4.19 4.19 0 018.36-.15l1.07 14.71 11.38-6.07h.23a3.12 3.12 0 01.52 0 2.85 2.85 0 011.69 5.11L654 286.35l11.6 183.53a4.22 4.22 0 01-1.11 3.2 4.34 4.34 0 01-3.21 1.41z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M647.51 261.18a2.61 2.61 0 012.68 2.47l1.23 17 13.2-7a1.14 1.14 0 01.26 0 1.35 1.35 0 01.78 2.42l-13.22 9.62L664.09 470a2.8 2.8 0 01-2.82 3h-27.64a2.8 2.8 0 01-2.83-2.92l11.59-170.21L629 286.38a.43.43 0 01.49-.7l13.38 6.53 1.8-26.43.1-2a2.62 2.62 0 012.7-2.57m0-3a5.63 5.63 0 00-5.69 5.42l-.11 2-1.49 21.94-9.33-4.57a3.42 3.42 0 00-4.67 1.77 3.4 3.4 0 00.73 3.73L639.3 301l-11.49 168.87v.05a5.79 5.79 0 001.58 4.26 5.91 5.91 0 004.25 1.81h27.64a5.9 5.9 0 004.32-1.89 5.8 5.8 0 001.49-4.35l-11.55-182.67 11.89-8.66a4.35 4.35 0 00-2.61-7.8 5.12 5.12 0 00-.78.06l-.47.09-.42.22-9.13 4.87-.9-12.39a5.62 5.62 0 00-5.67-5.25z",
    className: "mobilityStations_after_svg__cls-3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "mobilityStations_after_svg__cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.52 282l14.48-7.7a1.28 1.28 0 00-1.41-.7l-13.2 7zM645.56 293.5l1.88-27.72.11-2a2.59 2.59 0 011.32-2.23 2.7 2.7 0 00-4.06 2.23l-.1 2-1.79 26.43zM633.53 470.07l11.59-170.21-12.59-12.72-3-1.46a.43.43 0 00-.49.7l13.35 13.48-11.59 170.21a2.8 2.8 0 002.83 2.92h2.73a2.8 2.8 0 01-2.83-2.92z",
    className: "mobilityStations_after_svg__cls-22"
  })))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 145.77,
    x: 852.94,
    y: 393.8,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.97
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 86.92,
    height: 62.56,
    x: 810.88,
    y: 333.96,
    className: "mobilityStations_after_svg__cls-27",
    rx: 13.38
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_after_svg__cls-28",
    transform: "matrix(1.04 0 0 1 844.33 371.47)"
  }, "\r\n     P\r\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_after_svg__cls-29",
    transform: "matrix(1.04 0 0 1 817.12 389.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "mobilityStations_after_svg__cls-30"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.61,
    y: 0
  }, "arSha"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.78,
    y: 0,
    className: "mobilityStations_after_svg__cls-31"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.75,
    y: 0,
    className: "mobilityStations_after_svg__cls-32"
  }, "ing"))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M823.69 351.78v4.4h-4.4v-4.4h4.4m.42-.42h-5.23v5.24h5.23v-5.24z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 820.48,
    y: 352.96,
    className: "mobilityStations_after_svg__cls-33"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M835 351.78v4.4h-4.39v-4.4H835m.42-.42h-5.23v5.24h5.23v-5.24z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 831.76,
    y: 352.96,
    className: "mobilityStations_after_svg__cls-33"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M823.69 363v4.4h-4.4V363h4.4m.42-.41h-5.23v5.23h5.23v-5.23z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 820.48,
    y: 364.23,
    className: "mobilityStations_after_svg__cls-33"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M835 363v4.4h-4.39V363H835m.42-.41h-5.23v5.23h5.23v-5.23z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 831.74,
    y: 364.23,
    className: "mobilityStations_after_svg__cls-33"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M829.72 357v5.2h-5.19V357h5.19m.42-.41h-6v6h6v-6z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 826.12,
    y: 358.6,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 826.11,
    y: 362.63,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 826.12,
    y: 354.56,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 822.08,
    y: 358.6,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 830.16,
    y: 358.6,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 820.48,
    y: 360.62,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 820.48,
    y: 356.57,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 832.19,
    y: 360.63,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 832.19,
    y: 356.57,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 824.08,
    y: 364.65,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 828.14,
    y: 364.65,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 824.09,
    y: 352.53,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 828.16,
    y: 352.53,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 148.56,
    x: 1120.47,
    y: 393.8,
    className: "mobilityStations_after_svg__cls-34"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 86.92,
    height: 62.56,
    x: 1078.41,
    y: 334.04,
    className: "mobilityStations_after_svg__cls-27",
    rx: 13.38
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_after_svg__cls-28",
    transform: "matrix(1.04 0 0 1 1111.86 371.55)"
  }, "\r\n     P\r\n    ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_after_svg__cls-29",
    transform: "matrix(1.04 0 0 1 1084.65 389.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "mobilityStations_after_svg__cls-30"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.61,
    y: 0
  }, "arSha"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.78,
    y: 0,
    className: "mobilityStations_after_svg__cls-31"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.75,
    y: 0,
    className: "mobilityStations_after_svg__cls-32"
  }, "ing"))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.22 341.76v4.39h-4.4v-4.39h4.4m.42-.42h-5.24v5.23h5.24v-5.23z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1088.01,
    y: 342.93,
    className: "mobilityStations_after_svg__cls-33"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.48 341.76v4.39h-4.4v-4.39h4.4m.42-.42h-5.23v5.23h5.23v-5.23z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1099.29,
    y: 342.93,
    className: "mobilityStations_after_svg__cls-33"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.22 353v4.4h-4.4V353h4.4m.42-.42h-5.24v5.23h5.24v-5.21z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1088.01,
    y: 354.2,
    className: "mobilityStations_after_svg__cls-33"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.48 353v4.4h-4.4V353h4.4m.42-.42h-5.23v5.23h5.23v-5.21z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1099.27,
    y: 354.2,
    className: "mobilityStations_after_svg__cls-33"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.25 347v5.19h-5.19V347h5.19m.42-.42h-6v6h6v-6z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1093.65,
    y: 348.57,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1093.64,
    y: 352.6,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1093.65,
    y: 344.54,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1089.61,
    y: 348.58,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1097.69,
    y: 348.57,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1088.01,
    y: 350.6,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1088.01,
    y: 346.54,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1099.71,
    y: 350.6,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1099.71,
    y: 346.54,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1091.61,
    y: 354.63,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1095.67,
    y: 354.63,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1091.62,
    y: 342.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 1095.68,
    y: 342.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.11 443.84l19.41-9.38-16.17-15.22c-.34.17-23.53-4.46-23.87-4.29a16.2 16.2 0 00-2.3 1.35l-57.51-1.36-5.9 2.14c-.45-.22-1.35 1.36-1.8 1.15s-.23 1.65-.57 1.49l-17.68 16.63 20.28 10.21c4.92-7.14 11.16-12.07 25-10.84h28.21c15.08.17 27.24 3.63 32.9 8.12z",
    className: "mobilityStations_after_svg__cls-35"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.06 434.77h-33.61c-18.73 0-33.91 10.69-33.91 23.87l-17 3h137.39l-19-3c.07-13.18-15.13-23.87-33.87-23.87zm30.08 23.36h-93.68v-.46c0-11.67 13.45-21.14 30-21.14h33.6c16.59 0 30 9.47 30 21.14z",
    className: "mobilityStations_after_svg__cls-35"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 2.53,
    height: 13.36,
    x: 1085.99,
    y: 452.93,
    className: "mobilityStations_after_svg__cls-36",
    transform: "rotate(-29.97 1087.45 459.629)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 13.36,
    height: 2.53,
    x: 1091.65,
    y: 458.35,
    className: "mobilityStations_after_svg__cls-36",
    transform: "rotate(-60.02 1098.367 459.612)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.17 487.05a19.13 19.13 0 1119.12-19.12 19.15 19.15 0 01-19.12 19.12zm0-34.45a15.33 15.33 0 1015.33 15.33 15.34 15.34 0 00-15.33-15.33z",
    className: "mobilityStations_after_svg__cls-36"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 1011.83,
    y: 548.4,
    className: "mobilityStations_after_svg__cls-37",
    rx: 5.06
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 1181.42,
    y: 548.4,
    className: "mobilityStations_after_svg__cls-37",
    rx: 5.06
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.19 458.48a12.72 12.72 0 00-5.45-4.88s-6-3.34-17.66-1.15a3.13 3.13 0 00-1.58.72c-1.67 1.53-.86 4.88-.72 5.46 1 3.93 4.17 6.24 6.46 7.89a22.63 22.63 0 006.75 3.3 14.1 14.1 0 005.89.86c1.43-.14 5.07-.49 6.89-3.3 2.3-3.55-.17-8.17-.58-8.9zM1186.52 459.72a12.62 12.62 0 015.46-4.88s6-3.35 17.65-1.15a3 3 0 011.58.72c1.68 1.52.86 4.87.72 5.45-1 3.94-4.16 6.24-6.46 7.9a23.14 23.14 0 01-6.75 3.3 14.35 14.35 0 01-5.88.86c-1.44-.14-5.08-.5-6.89-3.3-2.31-3.55.16-8.17.57-8.9z",
    className: "mobilityStations_after_svg__cls-38"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.3 466.77c0-2.38-34.12-4.31-76.2-4.31s-76.21 1.93-76.21 4.31l-29.32 17.15 211.53.42z",
    className: "mobilityStations_after_svg__cls-35"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1222.92 485.75c-8-5.68-53.78-10-109.07-10-58.39 0-106.18 4.85-110 11a11.5 11.5 0 00-5.1 9.57v29.39c1.52 5.71 52.65 10.29 115.5 10.29s114-4.58 115.5-10.29v-29.43a11.51 11.51 0 00-6.83-10.53z",
    className: "mobilityStations_after_svg__cls-38"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1112.3,
    x2: 1112.29,
    y1: 431.36,
    y2: 439.32,
    className: "mobilityStations_after_svg__cls-39"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.72 526a5.05 5.05 0 00-2-4v3.65c-1.51 5.71-52.64 10.29-115.5 10.29s-114-4.58-115.5-10.29V522a5 5 0 00-1.92 4v17.66a4.7 4.7 0 00.15 1.2 1.54 1.54 0 00-.15.65c0 7 52.59 12.58 117.47 12.58s117.47-5.63 117.47-12.58a1.56 1.56 0 00-.16-.65 4.7 4.7 0 00.16-1.2z",
    className: "mobilityStations_after_svg__cls-40"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 21.91,
    height: 5.83,
    x: 1101.34,
    y: 436.41,
    className: "mobilityStations_after_svg__cls-36",
    rx: 2.15
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "1039.72 462.16 1184.15 464.29 1180.17 439.88 1165.43 423.92 1153.23 415.73 1124.91 413.63 1069.75 416.48 1055.6 426.06 1043.35 443.59 1039.72 462.16",
    className: "mobilityStations_after_svg__cls-41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1139 412.61h-49.62a50.07 50.07 0 00-50.07 50.07v3.26h149.76v-3.26a50.07 50.07 0 00-50.07-50.07zm44.4 49h-138.3v-.95a44.35 44.35 0 0144.35-44.36H1139a44.36 44.36 0 0144.36 44.36z",
    className: "mobilityStations_after_svg__cls-38"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 1002.15,
    y: 491.08,
    className: "mobilityStations_after_svg__cls-42",
    rx: 5.06
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 1196.66,
    y: 490.88,
    className: "mobilityStations_after_svg__cls-42",
    rx: 5.06
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 66.17,
    height: 16.17,
    x: 1075.41,
    y: 512.29,
    className: "mobilityStations_after_svg__cls-43",
    rx: 6.3
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.33 513.65v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1055.56,
    y: 514.66,
    className: "mobilityStations_after_svg__cls-33"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1068 513.65v3.78h-3.78v-3.78h3.78m.35-.36h-4.49v4.5h4.49v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1065.26,
    y: 514.66,
    className: "mobilityStations_after_svg__cls-33"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.33 523.33v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5V523z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1055.56,
    y: 524.34,
    className: "mobilityStations_after_svg__cls-33"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1068 523.33v3.78h-3.78v-3.78h3.78m.35-.36h-4.49v4.5h4.49V523z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1065.24,
    y: 524.34,
    className: "mobilityStations_after_svg__cls-33"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.51 518.14v4.47H1059v-4.47h4.47m.36-.35h-5.18V523h5.18v-5.18z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1060.42,
    y: 519.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1060.41,
    y: 522.97,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1060.42,
    y: 516.04,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1056.94,
    y: 519.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1063.88,
    y: 519.5,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1055.56,
    y: 521.25,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1055.56,
    y: 517.76,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1065.63,
    y: 521.25,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1065.63,
    y: 517.76,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1058.66,
    y: 524.71,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 1062.15,
    y: 524.71,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1058.67,
    y: 514.29,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 1062.16,
    y: 514.29,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 148.56,
    x: 587.31,
    y: 393.9,
    className: "mobilityStations_after_svg__cls-34"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 86.92,
    height: 62.56,
    x: 545.25,
    y: 334,
    className: "mobilityStations_after_svg__cls-27",
    rx: 13.38
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_after_svg__cls-28",
    transform: "matrix(1.04 0 0 1 578.7 371.51)"
  }, "\r\n     P\r\n    ")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "mobilityStations_after_svg__cls-29",
    transform: "matrix(1.04 0 0 1 551.49 389.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "mobilityStations_after_svg__cls-30"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.61,
    y: 0
  }, "arSha"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.78,
    y: 0,
    className: "mobilityStations_after_svg__cls-31"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.75,
    y: 0,
    className: "mobilityStations_after_svg__cls-32"
  }, "ing"))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M558.06 341.71v4.4h-4.4v-4.4h4.4m.42-.42h-5.24v5.24h5.24v-5.24z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 554.85,
    y: 342.89,
    className: "mobilityStations_after_svg__cls-33"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M569.32 341.71v4.4h-4.4v-4.4h4.4m.42-.42h-5.23v5.24h5.23v-5.24z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 566.13,
    y: 342.89,
    className: "mobilityStations_after_svg__cls-33"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M558.06 353v4.4h-4.4V353h4.4m.42-.41h-5.24v5.23h5.24v-5.23z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 554.85,
    y: 354.16,
    className: "mobilityStations_after_svg__cls-33"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M569.32 353v4.4h-4.4V353h4.4m.42-.41h-5.23v5.23h5.23v-5.23z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 566.11,
    y: 354.16,
    className: "mobilityStations_after_svg__cls-33"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M564.09 346.94v5.2h-5.2v-5.2h5.2m.42-.41h-6v6h6v-6z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 560.49,
    y: 348.53,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 560.48,
    y: 352.56,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 560.49,
    y: 344.49,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 556.45,
    y: 348.53,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 564.52,
    y: 348.53,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 554.85,
    y: 350.55,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 554.85,
    y: 346.5,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 566.55,
    y: 350.56,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 566.55,
    y: 346.5,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 558.45,
    y: 354.58,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 562.51,
    y: 354.58,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 558.46,
    y: 342.46,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03,
    height: 2.03,
    x: 562.52,
    y: 342.46,
    className: "mobilityStations_after_svg__cls-33"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M629 462.64l19.41-9.38-16.2-15.26c-.34.16-23.53-4.46-23.87-4.3a16.62 16.62 0 00-2.3 1.36l-57.51-1.36-5.9 2.13c-.45-.21-1.35 1.37-1.8 1.15s-.23 1.66-.57 1.49l-17.68 16.64 20.25 10.21c4.92-7.15 11.16-12.07 25-10.84H596c15.14.21 27.3 3.67 33 8.16z",
    className: "mobilityStations_after_svg__cls-44"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M602.92 453.57h-33.61c-18.73 0-33.92 10.68-33.92 23.87l-17 3h137.4l-18.95-3c0-13.19-15.19-23.87-33.92-23.87zM633 476.93h-93.69v-.46c0-11.68 13.45-21.14 30.05-21.14H603c16.59 0 30 9.46 30 21.14z",
    className: "mobilityStations_after_svg__cls-44"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 2.53,
    height: 13.36,
    x: 558.85,
    y: 471.73,
    className: "mobilityStations_after_svg__cls-36",
    transform: "rotate(-29.97 560.218 478.45)"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 13.36,
    height: 2.53,
    x: 564.51,
    y: 477.14,
    className: "mobilityStations_after_svg__cls-36",
    transform: "rotate(-60.02 571.209 478.408)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M566 505.85a19.13 19.13 0 1119.13-19.13A19.15 19.15 0 01566 505.85zm0-34.46a15.34 15.34 0 1015.33 15.33A15.35 15.35 0 00566 471.39z",
    className: "mobilityStations_after_svg__cls-36"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 484.69,
    y: 567.19,
    className: "mobilityStations_after_svg__cls-37",
    rx: 5.06
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 38.44,
    height: 25.98,
    x: 654.28,
    y: 567.19,
    className: "mobilityStations_after_svg__cls-37",
    rx: 5.06
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M514.05 477.28a12.62 12.62 0 00-5.46-4.88s-6-3.35-17.65-1.15a3.06 3.06 0 00-1.58.72c-1.68 1.52-.86 4.87-.72 5.45 1 3.94 4.16 6.25 6.46 7.9a23.14 23.14 0 006.75 3.3 14.19 14.19 0 005.88.86c1.44-.14 5.08-.5 6.89-3.3 2.31-3.55-.16-8.18-.57-8.9zM659.38 478.51a12.72 12.72 0 015.45-4.88s6-3.34 17.66-1.15a3.22 3.22 0 011.58.72c1.67 1.53.86 4.88.72 5.46-1 3.93-4.17 6.24-6.46 7.89a22.82 22.82 0 01-6.75 3.31 14.43 14.43 0 01-5.89.86c-1.43-.14-5.07-.5-6.89-3.3-2.3-3.56.2-8.18.58-8.91z",
    className: "mobilityStations_after_svg__cls-45"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M663.16 485.57c0-2.39-34.12-4.32-76.21-4.32s-76.2 1.93-76.2 4.32l-31.37 19.94 215.62-.57z",
    className: "mobilityStations_after_svg__cls-44"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M695.78 504.54c-8-5.67-53.78-10-109.08-10-58.39 0-106.17 4.85-110.05 11a11.52 11.52 0 00-5.1 9.56v29.4c1.51 5.71 52.64 10.29 115.5 10.29s114-4.58 115.5-10.29v-29.4a11.53 11.53 0 00-6.77-10.56z",
    className: "mobilityStations_after_svg__cls-45"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 585.16,
    x2: 585.15,
    y1: 450.16,
    y2: 458.12,
    className: "mobilityStations_after_svg__cls-39"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M704.57 544.79a5 5 0 00-2-4v3.66c-1.51 5.71-52.64 10.29-115.5 10.29s-114-4.58-115.5-10.29v-3.64a5.08 5.08 0 00-1.92 4v17.66a5.33 5.33 0 00.15 1.2 1.5 1.5 0 00-.15.64c0 7 52.6 12.59 117.47 12.59s117.47-5.64 117.47-12.59a1.5 1.5 0 00-.15-.64 4.81 4.81 0 00.15-1.2z",
    className: "mobilityStations_after_svg__cls-40"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 21.91,
    height: 5.83,
    x: 574.2,
    y: 455.2,
    className: "mobilityStations_after_svg__cls-36",
    rx: 2.15
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.09 484.24 659.53 486.37 655.54 461.96 640.8 445.99 628.61 437.81 600.28 435.7 545.12 438.55 530.97 448.14 518.72 465.67 515.09 484.24",
    className: "mobilityStations_after_svg__cls-41"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M611.85 431.41h-49.61a50.07 50.07 0 00-50.07 50.07v3.26h149.75v-3.26a50.07 50.07 0 00-50.07-50.07zm44.4 49H518v-1a44.35 44.35 0 0144.3-44.31h49.6a44.35 44.35 0 0144.35 44.35z",
    className: "mobilityStations_after_svg__cls-45"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 475,
    y: 509.88,
    className: "mobilityStations_after_svg__cls-42",
    rx: 5.06
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 28.91,
    height: 15.59,
    x: 669.51,
    y: 509.68,
    className: "mobilityStations_after_svg__cls-42",
    rx: 5.06
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 66.17,
    height: 16.17,
    x: 548.27,
    y: 531.09,
    className: "mobilityStations_after_svg__cls-43",
    rx: 6.3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.42 1009.82a10.09 10.09 0 01-7-3.16 8.26 8.26 0 01-2.21-6 107.46 107.46 0 017.84-33.59 97.48 97.48 0 0143.71-49.44c18-9.87 35.85-14.87 53-14.87a76.45 76.45 0 0131.46 6.52c31.49 14.08 47.18 59.27 42.09 92.64-.66 4.32-4.78 7.57-9.59 7.57a11.13 11.13 0 01-1.28-.08 9.85 9.85 0 01-6.69-3.72 8.1 8.1 0 01-1.62-6.17c4.09-26.76-7.84-63.95-31.48-74.52a55.4 55.4 0 00-22.79-4.7c-17 0-32.8 6.71-43.08 12.33-38.78 21.24-42 64-42.24 68.82s-4.47 8.37-9.66 8.37z",
    className: "mobilityStations_after_svg__cls-46"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.72 904.27a74.93 74.93 0 0130.85 6.39c30.13 13.47 46.41 57 41.21 91.05-.55 3.64-4.07 6.29-8.09 6.29a8.27 8.27 0 01-1.11-.07c-4.47-.54-7.61-4.2-7-8.18 4.25-27.87-8.47-65.42-32.36-76.11a56.77 56.77 0 00-23.4-4.83c-17.6 0-33.94 7.12-43.8 12.52-39.51 21.63-42.77 65.16-43 70-.2 3.91-3.82 7-8.17 7h-.36c-4.51-.18-8-3.57-7.81-7.58a105.92 105.92 0 017.73-33.1 96 96 0 0143-48.7c17.81-9.75 35.64-14.68 52.28-14.68m0-3c-17.4 0-35.47 5.06-53.72 15.05a99 99 0 00-44.38 50.19 109.24 109.24 0 00-7.95 34.09 9.7 9.7 0 002.61 7.07 11.56 11.56 0 008.08 3.65h.48c6 0 10.89-4.3 11.16-9.8.24-4.72 3.39-46.73 41.46-67.57 10.12-5.54 25.68-12.15 42.36-12.15a53.9 53.9 0 0122.17 4.57c10.41 4.65 19.35 15.3 25.17 30 5.51 13.89 7.5 29.54 5.45 42.94a9.62 9.62 0 001.9 7.31 11.39 11.39 0 007.71 4.3 12.08 12.08 0 001.47.09c5.53 0 10.29-3.8 11.06-8.84 2.65-17.39-.1-37.38-7.57-54.86-8-18.78-20.58-32.76-35.38-39.38a78 78 0 00-32.08-6.65z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 22.82,
    height: 7.88,
    x: 1009.79,
    y: 936.32,
    className: "mobilityStations_after_svg__cls-47",
    rx: 3.26
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "998.46 976.98 994.03 973.07 1019.02 940.27 1025.01 940.22 998.46 976.98",
    className: "mobilityStations_after_svg__cls-48"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "869.72 977.92 819.34 928.67 824.77 923.64 875.15 972.9 869.72 977.92",
    className: "mobilityStations_after_svg__cls-48"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 994.76,
    cy: 979.89,
    r: 22.64,
    className: "mobilityStations_after_svg__cls-49"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.32 973.55c1.59 6.51-.73 29.34-21.38 29-10.37-.18-132.23-8.51-128.24-29 2.82-14.49 85.32-16.3 128.24-16.3 0 0 17.39 0 21.38 16.3z",
    className: "mobilityStations_after_svg__cls-49"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M874.38 1048.24a75 75 0 1175-75 75.13 75.13 0 01-75 75zm0-142.92a67.88 67.88 0 1067.88 67.88 68 68 0 00-67.88-67.88z",
    className: "mobilityStations_after_svg__cls-48"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "1144.76 972.28 1115.04 908.4 1121.89 905.62 1151.62 969.5 1144.76 972.28",
    className: "mobilityStations_after_svg__cls-48"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M874.3 1054.8a81.63 81.63 0 1157.7-23.91 81 81 0 01-57.7 23.91zm0-156.14a74.53 74.53 0 1074.53 74.53 74.61 74.61 0 00-74.53-74.53zM1148.91 1054.8a81.62 81.62 0 1157.71-23.91 81.06 81.06 0 01-57.71 23.91zm0-156.14a74.53 74.53 0 1074.53 74.53 74.61 74.61 0 00-74.53-74.53z",
    className: "mobilityStations_after_svg__cls-50"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.48 886.39a89.6 89.6 0 00-64.62 3.81l-6.14-15.1a3.53 3.53 0 00-.82-3.47 3.59 3.59 0 00-.86-.66l-3.74-9.22a3.6 3.6 0 00-.1-2.4l-12.68-30.79a3.54 3.54 0 10-6.55 2.7l10.74 26.09-128 4.78-7.94-28A3.54 3.54 0 10949 836l8.2 29-28.29 35.83a89.23 89.23 0 00-118.26 7.62 90 90 0 00-26.25 63.83 4.44 4.44 0 008.87 0c0-44.9 36.25-81.42 80.79-81.42a80 80 0 0149.32 17l-52 65.88a3.54 3.54 0 002.61 5.73l115.2 5.8h.65l.26-.05h.11l.24-.07h.11l.25-.1h.09l.25-.13h.08l.26-.18.27-.24 109.86-104.63 5.29 13a90.48 90.48 0 00-47.53 79.75 4.44 4.44 0 008.87 0c0-44.9 36.24-81.43 80.79-81.43a80.39 80.39 0 0124.68 3.87 4.44 4.44 0 002.73-8.44zm-247.73 26a81.52 81.52 0 0126.07 59.85 4.44 4.44 0 003.4 4.31l-77.06-3.88zm31.1 64.24a4.43 4.43 0 003.84-4.39 90 90 0 00-26.25-63.83q-1.55-1.56-3.15-3l25.06-31.74 25.41 104.25zm31.47-1.76l-25.78-105.72 129.89-4.85 3.36 8.26z",
    className: "mobilityStations_after_svg__cls-51"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1148.91,
    cy: 973.19,
    r: 7.06,
    className: "mobilityStations_after_svg__cls-48"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.54 1047.41a75 75 0 1175-75 75.12 75.12 0 01-75 75zm0-142.92a67.88 67.88 0 1067.88 67.88 68 68 0 00-67.88-67.88z",
    className: "mobilityStations_after_svg__cls-48"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 945.31,
    cy: 824.84,
    className: "mobilityStations_after_svg__cls-52",
    rx: 37.86,
    ry: 10.14
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.58 769.67c.45-.45-1.84 2.8-2.7 5.85l-14.17 48.83-37.81 29.14c-2.58 1.85-5 2.15-3.15 4.73 1.13 1.56 1 1.53 2.84 1.53a5.73 5.73 0 003.35-1.08l36.88-26.46 5 11.76 7.33-3.12-7-16.43 13.39-47.66c.87-3.06-6.22-4.86-3.96-7.09z",
    className: "mobilityStations_after_svg__cls-48"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.76,
    cy: 980.25,
    r: 7.06,
    className: "mobilityStations_after_svg__cls-48"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 38.24,
    height: 5.8,
    x: 967.31,
    y: 994.56,
    className: "mobilityStations_after_svg__cls-48",
    transform: "rotate(-64.16 986.511 997.474)"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 30.43,
    height: 10.51,
    x: 964.51,
    y: 1010.86,
    className: "mobilityStations_after_svg__cls-50",
    rx: 4.35
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1089.49,
    x2: 1096.25,
    y1: 791.69,
    y2: 770.02,
    className: "mobilityStations_after_svg__cls-51"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.5 794.82l-8.74-4 3.66-17.25c.75-3.55 3.32-5.53 5.73-4.42 2.41 1.1 3.76 4.88 3 8.43z",
    className: "mobilityStations_after_svg__cls-51"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1052.89,
    x2: 1040.9,
    y1: 845.69,
    y2: 856.64,
    className: "mobilityStations_after_svg__cls-51"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.28 842.61l3.66 8.43-13.34 9.14c-2.74 1.88-5.79 1.51-6.8-.81-1-2.33.39-5.74 3.13-7.62z",
    className: "mobilityStations_after_svg__cls-51"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.56 1056.06a10.06 10.06 0 01-7-3.17 8.21 8.21 0 01-2.22-6 107.77 107.77 0 017.84-33.59 97.45 97.45 0 0143.72-49.44c18-9.87 35.85-14.87 53-14.87a76.53 76.53 0 0131.47 6.52c31.48 14.08 47.18 59.27 42.08 92.64-.66 4.32-4.78 7.57-9.58 7.57a10.86 10.86 0 01-1.28-.08 9.89 9.89 0 01-6.7-3.72 8.08 8.08 0 01-1.61-6.17c4.08-26.76-7.84-63.94-31.49-74.52a55.38 55.38 0 00-22.78-4.7c-17 0-32.81 6.71-43.08 12.33-38.8 21.25-42 64-42.24 68.82s-4.48 8.37-9.66 8.37z",
    className: "mobilityStations_after_svg__cls-46"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.86 950.5a75.06 75.06 0 0130.85 6.39c30.13 13.47 46.41 57 41.22 91.05-.56 3.64-4.08 6.29-8.1 6.29a8.27 8.27 0 01-1.11-.07c-4.47-.54-7.61-4.2-7-8.18 4.26-27.87-8.46-65.42-32.36-76.11A56.72 56.72 0 001157 965c-17.61 0-34 7.12-43.8 12.52-39.51 21.63-42.78 65.16-43 70.06-.19 3.9-3.81 6.94-8.16 6.94h-.37c-4.51-.18-8-3.57-7.81-7.58a106.23 106.23 0 017.73-33.1 96 96 0 0143-48.7c17.81-9.75 35.63-14.68 52.27-14.68m0-3c-17.4 0-35.47 5.06-53.71 15a99 99 0 00-44.39 50.2 109.56 109.56 0 00-8 34.08 9.77 9.77 0 002.61 7.08 11.61 11.61 0 008.08 3.64h.49c6 0 10.88-4.3 11.16-9.8.23-4.72 3.38-46.72 41.46-67.57 10.12-5.54 25.68-12.15 42.36-12.15a54 54 0 0122.17 4.57c10.41 4.66 19.35 15.3 25.17 30 5.51 13.89 7.49 29.54 5.44 42.94a9.66 9.66 0 001.9 7.31 11.4 11.4 0 007.71 4.3 12.08 12.08 0 001.47.09c5.54 0 10.29-3.8 11.06-8.84 2.66-17.39-.1-37.38-7.57-54.86-8-18.77-20.58-32.76-35.38-39.38a77.92 77.92 0 00-32.08-6.65z",
    className: "mobilityStations_after_svg__cls-3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#707384",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M195.52 1046.89L58 979.29a35.8 35.8 0 01-16.34-47.92l139.72-284.53a35.77 35.77 0 0147.89-16.35l137.53 67.6A35.8 35.8 0 01383.14 746l-139.73 284.54a35.78 35.78 0 01-47.89 16.35z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#46bea9",
    d: "M204.17 995.49L93.36 941a28.86 28.86 0 01-13.17-38.61l112.59-229.23A28.82 28.82 0 01231.36 660l110.82 54.46a28.85 28.85 0 0113.16 38.61L242.76 982.32a28.82 28.82 0 01-38.59 13.17z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.15,
    cy: 988.55,
    r: 13.13,
    className: "mobilityStations_after_svg__cls-55"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M313.75 691.23l-26.83-13.18a4.87 4.87 0 01-2.22-6.51 4.86 4.86 0 016.51-2.22L318 682.5a4.87 4.87 0 012.22 6.51 4.86 4.86 0 01-6.47 2.22z",
    className: "mobilityStations_after_svg__cls-55"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.88,
    cy: 666.71,
    r: 4.96,
    className: "mobilityStations_after_svg__cls-55"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#468cbe",
    d: "M276.9 912.82L114.38 833l79.75-162.41c6.3-12.83 23.06-17.51 37.43-10.45L342 714.38c14.37 7.06 20.91 23.2 14.6 36z"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 41.26,
    transform: "rotate(25.8 -1889.842 688.396)"
  }, "\r\n     Buchen\r\n    ")), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M212.51 712.08L240.88 726l-13.94 28.37-28.37-13.94 13.94-28.37m-1.37-4l-16.58 33.75 33.75 16.58 16.58-33.75-33.75-16.58z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 212.45,
    y: 725.9,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 219.753 733.28)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M285.14 747.78l28.36 13.94-13.94 28.36-28.36-13.94 13.94-28.36m-1.37-4l-16.58 33.75 33.74 16.58 16.59-33.74-33.75-16.59z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 285.23,
    y: 761.67,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 292.552 769.054)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M176.82 784.71l28.36 13.94L191.24 827l-28.36-13.94 13.94-28.36m-1.37-4l-16.59 33.74L192.61 831l16.59-33.75-33.75-16.55z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 176.74,
    y: 798.58,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 184.036 805.93)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M249.45 820.41l28.36 13.94-13.94 28.36-28.36-13.94 13.94-28.36m-1.37-4l-16.59 33.75 33.75 16.58L281.82 833l-33.74-16.59z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 249.37,
    y: 834.27,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 256.66 841.631)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M229.67 762.42l33.5 16.46-16.46 33.5-33.5-16.47 16.46-33.49m-1.36-4l-19.11 38.86 38.88 19.11 19.11-38.88-38.88-19.11z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 230.98,
    y: 780.17,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 238.283 787.54)"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 218.15,
    y: 806.1,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 225.44 813.448)"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 243.77,
    y: 754.15,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 251.079 761.53)"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 204.92,
    y: 767.38,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 212.229 774.754)"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 257.01,
    y: 792.94,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 264.305 800.288)"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 188.17,
    y: 775.33,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 195.458 782.688)"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 201.02,
    y: 749.18,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 208.315 756.55)"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 263.66,
    y: 812.45,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 270.95 819.808)"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 276.52,
    y: 786.29,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 283.803 793.648)"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 198.64,
    y: 812.75,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 205.925 820.116)"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 14.57,
    height: 14.57,
    x: 224.8,
    y: 825.6,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 232.085 832.968)"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 237.1,
    y: 734.6,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 244.402 741.972)"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 14.6,
    x: 263.31,
    y: 747.48,
    className: "mobilityStations_after_svg__cls-33",
    transform: "rotate(26.17 270.615 754.857)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.17 915.85V590.41v-1.2a62.12 62.12 0 11124.23 0v326.64z",
    className: "mobilityStations_after_svg__cls-58"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.29 528.59a60.62 60.62 0 0160.61 60.62c0 .9 0 1.81-.07 2.7h.07v322.44h-121.23V591.91h.07c0-.89-.07-1.8-.07-2.7a60.62 60.62 0 0160.62-60.62m0-3a63.69 63.69 0 00-63.62 63.32v328.44h127.23V588.91a63.69 63.69 0 00-63.61-63.32z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 5.76,
    height: 1.99,
    x: 1154.88,
    y: 595.64,
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.21,
    rx: 0.82
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "1152.02 605.89 1150.9 604.91 1157.21 596.63 1158.72 596.62 1152.02 605.89",
    className: "mobilityStations_after_svg__cls-60"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "1119.54 606.13 1106.82 593.7 1108.19 592.44 1120.91 604.86 1119.54 606.13",
    className: "mobilityStations_after_svg__cls-60"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1151.09,
    cy: 606.63,
    r: 5.71,
    className: "mobilityStations_after_svg__cls-61"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.52 605c.41 1.64-.18 7.4-5.39 7.31-2.62 0-33.36-2.15-32.36-7.31.71-3.66 21.53-4.12 32.36-4.12 0 .03 4.39.03 5.39 4.12z",
    className: "mobilityStations_after_svg__cls-61"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.71 623.87a18.93 18.93 0 1118.93-18.93 18.95 18.95 0 01-18.93 18.93zm0-36.06a17.13 17.13 0 1017.13 17.13 17.16 17.16 0 00-17.13-17.13z",
    className: "mobilityStations_after_svg__cls-60"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "1188.93 604.71 1181.43 588.59 1183.16 587.89 1190.67 604.01 1188.93 604.71",
    className: "mobilityStations_after_svg__cls-60"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.69 625.53a20.59 20.59 0 1114.56-6 20.45 20.45 0 01-14.56 6zm0-39.4a18.81 18.81 0 1018.81 18.81 18.83 18.83 0 00-18.81-18.81zM1190 625.53a20.59 20.59 0 1114.56-6 20.45 20.45 0 01-14.56 6zm0-39.4a18.81 18.81 0 1018.81 18.81 18.83 18.83 0 00-18.81-18.81z",
    className: "mobilityStations_after_svg__cls-62"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.94 583a22.52 22.52 0 00-16.31 1l-1.55-3.81a.9.9 0 00-.2-.88 1.18 1.18 0 00-.22-.17l-.94-2.32a.92.92 0 000-.61l-3.2-7.77a.89.89 0 00-1.65.68l2.71 6.59-32.3 1.2-2-7.06a.89.89 0 00-1.72.48l2.07 7.31-7.14 9a22.53 22.53 0 00-29.84 1.92 22.71 22.71 0 00-6.62 16.11 1.12 1.12 0 002.24 0 20.49 20.49 0 0120.38-20.55 20.18 20.18 0 0112.45 4.29l-13.13 16.62a.9.9 0 00-.11.92.88.88 0 00.77.52l29.07 1.47h.51l.07-.06 27.72-26.4 1.33 3.28a22.85 22.85 0 00-12 20.13 1.12 1.12 0 002.24 0 20.49 20.49 0 0120.43-20.7 20.19 20.19 0 016.23 1 1.12 1.12 0 10.69-2.13zm-62.51 6.57a20.55 20.55 0 016.58 15.1 1.12 1.12 0 00.86 1.09l-19.45-1zm7.85 16.21a1.13 1.13 0 001-1.11 22.72 22.72 0 00-6.63-16.11c-.26-.26-.52-.52-.79-.76l6.32-8 6.41 26.3zm7.94-.45l-6.51-26.68 32.78-1.23.84 2.09z",
    className: "mobilityStations_after_svg__cls-63"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189.98,
    cy: 604.94,
    r: 1.78,
    className: "mobilityStations_after_svg__cls-60"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.14 623.67a18.94 18.94 0 1118.93-18.94 19 19 0 01-18.93 18.94zm0-36.07a17.13 17.13 0 1017.13 17.13 17.16 17.16 0 00-17.13-17.13z",
    className: "mobilityStations_after_svg__cls-60"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1138.61,
    cy: 567.5,
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    rx: 9.55,
    ry: 2.56
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 553.58a12.3 12.3 0 00-.68 1.48l-3.57 12.32-9.54 7.35c-.65.47-1.26.55-.8 1.2.29.39.27.38.72.38a1.45 1.45 0 00.84-.27l9.31-6.68 1.26 3 1.85-.79-1.76-4.14 3.38-12c.22-.83-1.53-1.28-1.01-1.85z",
    className: "mobilityStations_after_svg__cls-60"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1151.09,
    cy: 606.72,
    r: 1.78,
    className: "mobilityStations_after_svg__cls-60"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 9.65,
    height: 1.46,
    x: 1144.16,
    y: 610.33,
    className: "mobilityStations_after_svg__cls-60",
    transform: "rotate(-64.16 1149.065 611.061)"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 7.68,
    height: 2.65,
    x: 1143.45,
    y: 614.44,
    className: "mobilityStations_after_svg__cls-62",
    rx: 1.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1174.99,
    x2: 1176.69,
    y1: 559.14,
    y2: 553.67,
    className: "mobilityStations_after_svg__cls-63"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.76 559.93l-2.21-1 .93-4.35c.18-.9.83-1.4 1.44-1.12a1.94 1.94 0 01.76 2.13z",
    className: "mobilityStations_after_svg__cls-63"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1165.75,
    x2: 1162.73,
    y1: 572.77,
    y2: 575.53,
    className: "mobilityStations_after_svg__cls-63"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.6 572l.92 2.13-3.36 2.3c-.7.48-1.46.38-1.72-.2a1.74 1.74 0 01.79-1.93z",
    className: "mobilityStations_after_svg__cls-63"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 21.13,
    height: 7.29,
    x: 1024.93,
    y: 898.67,
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    rx: 3.02
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "1014.44 936.3 1010.33 932.69 1033.47 902.33 1039.01 902.28 1014.44 936.3",
    className: "mobilityStations_after_svg__cls-66"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "895.26 937.18 848.63 891.59 853.66 886.93 900.29 932.53 895.26 937.18",
    className: "mobilityStations_after_svg__cls-66"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.01,
    cy: 939,
    r: 20.96,
    className: "mobilityStations_after_svg__cls-67"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1031 933.13c1.47 6-.68 27.16-19.79 26.83-9.6-.17-122.4-7.88-118.71-26.83 2.61-13.41 79-15.09 118.71-15.09-.03-.04 16.07-.04 19.79 15.09z",
    className: "mobilityStations_after_svg__cls-67"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M899.58 1002.27A69.47 69.47 0 11969 932.8a69.54 69.54 0 01-69.42 69.47zm0-132.3a62.84 62.84 0 1062.83 62.83 62.9 62.9 0 00-62.83-62.8z",
    className: "mobilityStations_after_svg__cls-66"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "1149.87 931.96 1122.35 872.83 1128.69 870.25 1156.21 929.38 1149.87 931.96",
    className: "mobilityStations_after_svg__cls-66"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M899.51 1008.34a75.56 75.56 0 1153.42-22.13 75.05 75.05 0 01-53.42 22.13zm0-144.53a69 69 0 1069 69 69.06 69.06 0 00-69-69zM1153.7 1008.34a75.54 75.54 0 1153.42-22.13 75.05 75.05 0 01-53.42 22.13zm0-144.53a69 69 0 1069 69 69.06 69.06 0 00-69-69z",
    className: "mobilityStations_after_svg__cls-68"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1153.7,
    cy: 932.79,
    r: 6.54,
    className: "mobilityStations_after_svg__cls-66"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.13 851.63a85.64 85.64 0 00-60 3.48l-5.7-13.64a3.14 3.14 0 00-.77-3.14 3.29 3.29 0 00-.8-.6l-3.48-8.32a3.12 3.12 0 00-.09-2.17l-11.73-27.65a3.46 3.46 0 00-4.21-2 3.19 3.19 0 00-2 4.24l10 23.57-119.08 4.32-7.27-25.1a3.44 3.44 0 00-4-2.43 3.2 3.2 0 00-2.45 4l7.64 26.15-26.33 32.38a84.85 84.85 0 00-110 6.87 80.17 80.17 0 00-24.42 57.53 4.14 4.14 0 003.74 4.12 4.08 4.08 0 004.51-4c0-40.56 45.92-13.59 87.37-13.59l-14.7 14.88a3.13 3.13 0 00.19 4.19 3.46 3.46 0 002.33 1L1007 941h.95l.23-.06h.1a.85.85 0 00.22-.09h.1l.22-.12h.08l.24-.16a1.71 1.71 0 00.26-.21l102.21-94.52 4.92 11.77a83.93 83.93 0 00-19.8 14.38 80.17 80.17 0 00-24.42 57.53 4.15 4.15 0 003.74 4.12 4.08 4.08 0 004.51-4c0-40.55 33.72-73.55 75.17-73.55a76.58 76.58 0 0123 3.49 4.15 4.15 0 005.3-2.94 4.1 4.1 0 00-2.9-5.01zm-230.36 23.56A72.66 72.66 0 01975 929.26c0 1.89 2.56 3.19 4.38 3.61l-72.91-3.23zm28.64 57.68c2-.26 3.87-1.58 3.87-3.61a80.11 80.11 0 00-24.42-57.67c-1-.94-1.94-1.85-2.93-2.74l23.31-28.68 23.65 94.18zm29.58-1.24l-24-95.54 120.85-4.38 3.12 7.46z",
    className: "mobilityStations_after_svg__cls-69"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.29 1001.5a69.46 69.46 0 1169.46-69.5 69.54 69.54 0 01-69.46 69.5zm0-132.29a62.83 62.83 0 1062.83 62.79 62.89 62.89 0 00-62.83-62.79z",
    className: "mobilityStations_after_svg__cls-66"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 965.24,
    cy: 795.47,
    fill: "#191919",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.19,
    rx: 35.04,
    ry: 9.39
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.53 744.41c.42-.42-1.7 2.59-2.49 5.42L1089.91 795l-35 27c-2.39 1.71-4.63 2-2.91 4.37 1 1.45 1 1.42 2.62 1.42a5.32 5.32 0 003.1-1l34.14-24.5 4.64 10.89 6.79-2.89-6.47-15.2 12.4-44.09c.78-2.86-5.78-4.53-3.69-6.59z",
    className: "mobilityStations_after_svg__cls-66"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.01,
    cy: 939.33,
    r: 6.54,
    className: "mobilityStations_after_svg__cls-66"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 35.4,
    height: 5.37,
    x: 985.6,
    y: 952.58,
    className: "mobilityStations_after_svg__cls-66",
    transform: "rotate(-64.16 1003.38 955.282)"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 28.17,
    height: 9.72,
    x: 983.01,
    y: 967.67,
    className: "mobilityStations_after_svg__cls-68",
    rx: 4.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1098.7,
    x2: 1104.96,
    y1: 764.79,
    y2: 744.74,
    fill: "#f84c34",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.19
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.19 767.69l-8.09-3.69 3.39-16c.69-3.29 3.07-5.12 5.3-4.1 2.23 1 3.48 4.52 2.78 7.81z",
    className: "mobilityStations_after_svg__cls-69"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1065.77,
    x2: 1054.68,
    y1: 815.63,
    y2: 825.76,
    className: "mobilityStations_after_svg__cls-69"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.2 812.77l3.4 7.81-12.35 8.42c-2.54 1.74-5.36 1.4-6.3-.75-.94-2.16.36-5.32 2.9-7.06z",
    className: "mobilityStations_after_svg__cls-69"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.88 1011.81a10.09 10.09 0 01-7-3.16 8.23 8.23 0 01-2.22-6 107.81 107.81 0 017.84-33.6 97.48 97.48 0 0143.71-49.44c18-9.87 35.86-14.87 53-14.87a76.45 76.45 0 0131.46 6.52c31.49 14.08 47.18 59.28 42.09 92.65-.66 4.31-4.78 7.56-9.58 7.56a11.17 11.17 0 01-1.29-.08 9.83 9.83 0 01-6.69-3.72 8.07 8.07 0 01-1.61-6.17c4.08-26.76-7.85-63.94-31.49-74.52a55.4 55.4 0 00-22.79-4.7c-17 0-32.8 6.71-43.07 12.33-38.8 21.25-42 64-42.24 68.82s-4.48 8.38-9.66 8.38z",
    className: "mobilityStations_after_svg__cls-46"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.18 906.25a75.09 75.09 0 0130.85 6.39c30.13 13.48 46.41 57 41.21 91.05-.55 3.65-4.07 6.29-8.09 6.29a8.27 8.27 0 01-1.11-.07c-4.47-.54-7.61-4.2-7-8.17 4.25-27.87-8.47-65.43-32.36-76.12a56.93 56.93 0 00-23.4-4.83c-17.6 0-33.94 7.12-43.8 12.52-39.5 21.63-42.77 65.17-43 70.06-.2 3.9-3.82 7-8.17 7h-.36c-4.51-.18-8-3.57-7.81-7.58a106.28 106.28 0 017.73-33.1 96 96 0 0143-48.69c17.81-9.76 35.64-14.69 52.28-14.69m0-3c-17.4 0-35.47 5.06-53.72 15.06a98.92 98.92 0 00-44.38 50.19 109.56 109.56 0 00-7.95 34.08 9.77 9.77 0 002.61 7.08 11.66 11.66 0 008.08 3.65h.48c6 0 10.89-4.31 11.16-9.8.24-4.72 3.4-46.73 41.47-67.58 10.11-5.54 25.68-12.15 42.35-12.15a53.9 53.9 0 0122.17 4.57c10.42 4.66 19.36 15.31 25.18 30 5.5 13.89 7.49 29.54 5.44 42.94a9.62 9.62 0 001.9 7.31 11.35 11.35 0 007.71 4.3 12.08 12.08 0 001.47.09c5.53 0 10.29-3.8 11.06-8.84 2.65-17.38-.1-37.38-7.57-54.85-8-18.78-20.58-32.77-35.38-39.39a78.12 78.12 0 00-32.08-6.65z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 22.82,
    height: 7.88,
    x: 1009.26,
    y: 936.31,
    className: "mobilityStations_after_svg__cls-47",
    rx: 3.26
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "997.92 976.96 993.49 973.05 1018.49 940.26 1024.47 940.2 997.92 976.96",
    className: "mobilityStations_after_svg__cls-48"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "869.18 977.91 818.8 928.65 824.24 923.63 874.61 972.88 869.18 977.91",
    className: "mobilityStations_after_svg__cls-48"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.22,
    cy: 979.87,
    r: 22.64,
    className: "mobilityStations_after_svg__cls-49"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.78 973.53c1.59 6.51-.73 29.35-21.38 29-10.37-.18-132.23-8.51-128.24-29 2.82-14.49 85.33-16.3 128.24-16.3 0 0 17.39 0 21.38 16.3z",
    className: "mobilityStations_after_svg__cls-49"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M873.84 1048.22a75 75 0 1175-75 75.12 75.12 0 01-75 75zm0-142.92a67.88 67.88 0 1067.88 67.88 68 68 0 00-67.88-67.88z",
    className: "mobilityStations_after_svg__cls-48"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "1144.23 972.26 1114.5 908.39 1121.36 905.61 1151.09 969.48 1144.23 972.26",
    className: "mobilityStations_after_svg__cls-48"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M873.77 1054.78a81.62 81.62 0 1157.7-23.9 81.09 81.09 0 01-57.7 23.9zm0-156.14a74.53 74.53 0 1074.52 74.53 74.61 74.61 0 00-74.52-74.53zM1148.37 1054.78a81.6 81.6 0 1157.71-23.9 81.09 81.09 0 01-57.71 23.9zm0-156.14a74.53 74.53 0 1074.53 74.53 74.61 74.61 0 00-74.53-74.53z",
    className: "mobilityStations_after_svg__cls-50"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.8 886.33a89.56 89.56 0 00-64.48 3.85l-6.14-15.1a3.53 3.53 0 00-.82-3.47 3.59 3.59 0 00-.86-.66l-3.74-9.22a3.57 3.57 0 00-.1-2.39l-12.61-30.61a3.67 3.67 0 00-4.52-2.18 3.54 3.54 0 00-2.1 4.69l10.74 26.09-128 4.78-7.88-27.82a3.67 3.67 0 00-4.25-2.68 3.54 3.54 0 00-2.62 4.42l8.2 29-28.29 35.84a89.22 89.22 0 00-118.26 7.61 90 90 0 00-26.24 63.69 4.54 4.54 0 004 4.56 4.43 4.43 0 004.85-4.42c0-44.89 49.36-15 93.91-15l-15.8 16.46a3.55 3.55 0 00.21 4.64 3.65 3.65 0 002.5 1.1l115.09 5.79h.18a2.17 2.17 0 00.36 0h.48l.25-.07h.11l.24-.1h.1l.24-.13h.08a1.51 1.51 0 00.26-.18h.05l.27-.23 109.86-104.64 5.29 13a90.51 90.51 0 00-47.52 79.61 4.54 4.54 0 004 4.56 4.43 4.43 0 004.85-4.42c0-44.89 36.25-81.42 80.79-81.42a80 80 0 0124.68 3.87 4.44 4.44 0 005.69-3.26 4.54 4.54 0 00-3.05-5.56zm-247.59 26.08a81.52 81.52 0 0126.07 59.85 4.43 4.43 0 003.41 4.31l-77.07-3.88zm31.1 64.24a4.43 4.43 0 003.84-4.39 90 90 0 00-26.25-63.83q-1.54-1.56-3.15-3l25.06-31.75 25.41 104.26zm31.47-1.75L965 869.13l129.89-4.85 3.36 8.26z",
    className: "mobilityStations_after_svg__cls-69"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1148.37,
    cy: 973.17,
    r: 7.06,
    className: "mobilityStations_after_svg__cls-48"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1149 1047.39a75 75 0 1175-75 75.13 75.13 0 01-75 75zm0-142.91a67.88 67.88 0 1067.88 67.87 68 68 0 00-67.88-67.87z",
    className: "mobilityStations_after_svg__cls-48"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 944.77,
    cy: 824.82,
    className: "mobilityStations_after_svg__cls-52",
    rx: 37.86,
    ry: 10.14
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1095 769.65c.45-.44-1.84 2.8-2.7 5.86l-14.17 48.82-37.81 29.14c-2.57 1.85-5 2.15-3.15 4.73 1.13 1.56 1 1.53 2.84 1.53a5.71 5.71 0 003.35-1.08l36.88-26.46 5 11.76 7.33-3.12-7-16.43 13.43-47.66c.88-3.05-6.22-4.86-4-7.09z",
    className: "mobilityStations_after_svg__cls-48"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.22,
    cy: 980.23,
    r: 7.06,
    className: "mobilityStations_after_svg__cls-48"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 38.24,
    height: 5.8,
    x: 966.77,
    y: 994.54,
    className: "mobilityStations_after_svg__cls-48",
    transform: "rotate(-64.16 985.975 997.46)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 30.43,
    height: 10.51,
    x: 963.97,
    y: 1010.85,
    className: "mobilityStations_after_svg__cls-50",
    rx: 4.35
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1088.96,
    x2: 1095.71,
    y1: 791.67,
    y2: 770.01,
    className: "mobilityStations_after_svg__cls-51"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1096 794.8l-8.74-4 3.66-17.25c.75-3.55 3.32-5.53 5.73-4.42 2.41 1.11 3.76 4.88 3 8.43z",
    className: "mobilityStations_after_svg__cls-51"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1052.36,
    x2: 1040.36,
    y1: 845.67,
    y2: 856.62,
    className: "mobilityStations_after_svg__cls-51"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1051.74 842.59l3.67 8.43-13.35 9.14c-2.74 1.88-5.79 1.52-6.8-.81-1-2.33.39-5.74 3.14-7.62z",
    className: "mobilityStations_after_svg__cls-51"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1061 1056a10.11 10.11 0 01-7-3.16 8.27 8.27 0 01-2.22-6 107.81 107.81 0 017.84-33.6 97.49 97.49 0 0143.72-49.44c18-9.87 35.85-14.87 53-14.87a76.5 76.5 0 0131.47 6.52c31.48 14.08 47.18 59.28 42.08 92.65-.66 4.31-4.78 7.56-9.58 7.56a9.07 9.07 0 01-1.28-.08 9.86 9.86 0 01-6.7-3.72 8.11 8.11 0 01-1.61-6.17c4.08-26.76-7.84-63.94-31.49-74.52a55.51 55.51 0 00-22.78-4.7c-17 0-32.81 6.71-43.08 12.34-38.79 21.24-42 64-42.24 68.81s-4.48 8.38-9.66 8.38z",
    className: "mobilityStations_after_svg__cls-46"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.32 950.48a75.14 75.14 0 0130.86 6.39c30.12 13.48 46.4 57 41.21 91.05-.56 3.65-4.07 6.29-8.1 6.29a10.28 10.28 0 01-1.1-.06c-4.48-.54-7.62-4.21-7-8.18 4.26-27.87-8.46-65.43-32.36-76.12a56.88 56.88 0 00-23.39-4.83c-17.61 0-34 7.12-43.8 12.52-39.51 21.64-42.78 65.17-43 70.06-.19 3.9-3.81 7-8.16 7h-.37c-4.51-.18-8-3.57-7.81-7.58a106.28 106.28 0 017.73-33.1 96 96 0 0143-48.69c17.81-9.75 35.63-14.69 52.27-14.69m0-3c-17.4 0-35.47 5.07-53.71 15.06a99 99 0 00-44.39 50.19 109.12 109.12 0 00-7.94 34.08 9.71 9.71 0 002.6 7.08 11.58 11.58 0 008.09 3.65h.48c6 0 10.89-4.31 11.16-9.8.23-4.72 3.39-46.73 41.46-67.58 10.12-5.54 25.68-12.15 42.36-12.15a54 54 0 0122.17 4.57c10.41 4.66 19.35 15.31 25.17 30 5.51 13.89 7.49 29.54 5.45 42.94a9.58 9.58 0 001.9 7.31 11.35 11.35 0 007.71 4.3 11.8 11.8 0 001.46.09c5.54 0 10.29-3.8 11.06-8.84 2.66-17.38-.1-37.38-7.56-54.85-8-18.78-20.59-32.77-35.39-39.39a78.08 78.08 0 00-32.08-6.65z",
    className: "mobilityStations_after_svg__cls-3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.93 649.69V668h-18.31v-18.31h18.31m1.74-1.74h-21.79v21.79h21.79V648z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1128.55,
    y: 654.59,
    className: "mobilityStations_after_svg__cls-33"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.81 649.69V668h-18.31v-18.31h18.31m1.74-1.74h-21.79v21.79h21.79V648z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1175.53,
    y: 654.59,
    className: "mobilityStations_after_svg__cls-33"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.93 696.58v18.31h-18.31v-18.31h18.31m1.74-1.74h-21.79v21.78h21.79v-21.78z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1128.55,
    y: 701.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.81 696.58v18.31h-18.31v-18.31h18.31m1.74-1.74h-21.79v21.78h21.79v-21.78z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1175.44,
    y: 701.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1167 671.48v21.62h-21.6v-21.62h21.6m1.73-1.74h-25.09v25.1h25.09v-25.1z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1152.05,
    y: 678.08,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1152,
    y: 694.84,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1152.05,
    y: 661.28,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1135.24,
    y: 678.08,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1168.85,
    y: 678.07,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1128.55,
    y: 686.5,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1128.55,
    y: 669.62,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1177.29,
    y: 686.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1177.29,
    y: 669.62,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1143.56,
    y: 703.28,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 8.44,
    x: 1160.44,
    y: 703.28,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1143.59,
    y: 652.82,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 8.46,
    height: 8.46,
    x: 1160.51,
    y: 652.82,
    className: "mobilityStations_after_svg__cls-33"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M300.34 539.52V344.89c0-20.68 17.15-37.5 38.24-37.5s38.23 16.82 38.23 37.5v194.63z",
    className: "mobilityStations_after_svg__cls-58"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M338.58 308.89c20.29 0 36.73 16.12 36.73 36V538h-73.47V346.5v-1.61c0-19.88 16.45-36 36.74-36m0-3c-21.91 0-39.74 17.5-39.74 39V541h79.47V343.5c-.75-20.86-18.28-37.61-39.71-37.61z",
    className: "mobilityStations_after_svg__cls-3"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 1.15,
    x: 330.19,
    y: 352.21,
    className: "mobilityStations_after_svg__cls-72",
    rx: 0.57
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 1.15,
    x: 343.67,
    y: 361.5,
    className: "mobilityStations_after_svg__cls-72",
    rx: 0.57
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M345.43 361.53a.56.56 0 01-.56-.58l.05-3.1-2.94-.13a.58.58 0 01-.55-.59.59.59 0 01.61-.54l3.49.15a.57.57 0 01.55.58L346 361a.58.58 0 01-.57.53zM335.46 357.73l-3.5-.15a.57.57 0 01-.55-.58l.06-3.65a.58.58 0 01.58-.56.58.58 0 01.57.58l-.06 3.1 2.94.13a.57.57 0 110 1.13z",
    className: "mobilityStations_after_svg__cls-73"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 0.65,
    height: 1.11,
    x: 336.8,
    y: 356.61,
    className: "mobilityStations_after_svg__cls-74"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 0.65,
    height: 1.11,
    x: 340.05,
    y: 356.61,
    className: "mobilityStations_after_svg__cls-74"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 19.71,
    height: 26.75,
    x: 328.79,
    y: 330.48,
    fill: "#fff",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.86
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 3.01,
    height: 31.34,
    x: 337.23,
    y: 341.35,
    fill: "#455064",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.57,
    rx: 1.49
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 0.99,
    height: 2.79,
    x: 335.96,
    y: 337.93,
    className: "mobilityStations_after_svg__cls-77"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 0.99,
    height: 2.79,
    x: 340.61,
    y: 337.93,
    className: "mobilityStations_after_svg__cls-77"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.57,
    d: "M340.71 340.16h-4.06a1.18 1.18 0 00-1.19 1.17v16.3a.71.71 0 00.71.71h0a.71.71 0 00.71-.71v-16.27a4.7 4.7 0 013.59-.11v16.38a.72.72 0 001.43 0v-16.3a1.18 1.18 0 00-1.19-1.17z"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 0.84,
    height: 5.16,
    x: 335.31,
    y: 354.65,
    className: "mobilityStations_after_svg__cls-72",
    rx: 0.42
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 0.84,
    height: 5.16,
    x: 341.58,
    y: 354.65,
    className: "mobilityStations_after_svg__cls-72",
    rx: 0.42
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M341.9 337.36a.59.59 0 00-.4-.17 4.68 4.68 0 01-1.28-.39c-.09 0-.44-.18-.71-.32v-.7h-1.67v.7c-.27.14-.62.28-.7.32a4.74 4.74 0 01-1.29.39.58.58 0 00-.39.17.56.56 0 00-.07.48.63.63 0 00.29.37c.17.09.33.05.95-.08l.59-.13a7.07 7.07 0 011.17-.18h.61a7.12 7.12 0 011.16.18l.59.13c.62.13.78.17 1 .08a.6.6 0 00.28-.37.59.59 0 00-.13-.48z",
    className: "mobilityStations_after_svg__cls-79"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.32,
    d: "M337.47 332.68h2.42v3a.31.31 0 01-.31.31h-1.8a.31.31 0 01-.31-.31v-3h0z"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 4.15,
    height: 2.53,
    x: 336.59,
    y: 330.24,
    className: "mobilityStations_after_svg__cls-79",
    rx: 0.74
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 3.78,
    height: 2.04,
    x: 336.78,
    y: 330.48,
    fill: "#aec2dd",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 0.32,
    rx: 0.63
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 0.32,
    d: "M338.65 325.75h0a.77.77 0 01.77.77v3.86h0-1.55 0v-3.86a.77.77 0 01.78-.77z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M328.6 325.75h-4.14a.63.63 0 110-1.25h4.14a.63.63 0 110 1.25z",
    className: "mobilityStations_after_svg__cls-83"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M328.79 325.09a12.87 12.87 0 003 0c1.24-.13 1.91-.39 2.44 0s.37.93 1 1.36a2.42 2.42 0 00.88.31 5.81 5.81 0 002.13 0",
    className: "mobilityStations_after_svg__cls-84"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M348.83 325.75H353a.63.63 0 100-1.25h-4.14a.63.63 0 100 1.25z",
    className: "mobilityStations_after_svg__cls-83"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M348.64 325.09a12.78 12.78 0 01-3 0c-1.25-.13-1.92-.39-2.45 0s-.37.93-1 1.36a2.42 2.42 0 01-.88.31 5.81 5.81 0 01-2.13 0",
    className: "mobilityStations_after_svg__cls-84"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 336.8,
    x2: 330.68,
    y1: 357.72,
    y2: 372.31,
    fill: "#cc4058",
    stroke: "#2c3d4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.73
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 351.42,
    y: 555.1,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.87
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 394.72,
    y: 585.39,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.87
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M400.36 585.47a1.85 1.85 0 01-1.82-1.88l.18-10.11-9.43-.42a1.85 1.85 0 01-1.77-1.93 1.88 1.88 0 011.93-1.77l11.23.5a1.85 1.85 0 011.77 1.88l-.21 11.92a1.84 1.84 0 01-1.88 1.81z",
    className: "mobilityStations_after_svg__cls-87"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M368.35 573.1h-.09l-11.26-.5a1.86 1.86 0 01-1.77-1.88l.21-11.91a1.85 1.85 0 011.85-1.82 1.84 1.84 0 011.81 1.88L359 569l9.43.42a1.85 1.85 0 01-.08 3.7z",
    className: "mobilityStations_after_svg__cls-88"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 372.64,
    y: 569.43,
    className: "mobilityStations_after_svg__cls-74"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 383.07,
    y: 569.43,
    className: "mobilityStations_after_svg__cls-74"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 63.31,
    height: 87.2,
    x: 346.94,
    y: 484.25,
    fill: "#cc4058",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 9.67,
    height: 102.16,
    x: 374.02,
    y: 519.67,
    className: "mobilityStations_after_svg__cls-90",
    rx: 4.83
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 369.94,
    y: 508.54,
    className: "mobilityStations_after_svg__cls-87"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 384.89,
    y: 508.54,
    className: "mobilityStations_after_svg__cls-87"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M385.2 515.8h-13.05a3.81 3.81 0 00-3.8 3.81v53.16a2.29 2.29 0 002.28 2.29 2.3 2.3 0 002.29-2.29v-53.06a14.79 14.79 0 0111.51-.34v53.4a2.29 2.29 0 104.57 0v-53.16a3.81 3.81 0 00-3.8-3.81z",
    className: "mobilityStations_after_svg__cls-91"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 367.86,
    y: 563.04,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.35
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 387.99,
    y: 563.04,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.35
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M389 506.66a1.85 1.85 0 00-1.26-.53 15 15 0 01-4.13-1.29c-.26-.11-1.38-.58-2.25-1v-2.29H376v2.29c-.87.44-2 .91-2.26 1a15 15 0 01-4.13 1.29 1.87 1.87 0 00-1.26.53 1.83 1.83 0 00-.2 1.58 2.06 2.06 0 00.9 1.21c.56.3 1.08.17 3.08-.27l1.88-.41a23.59 23.59 0 013.75-.58h1.86a23.59 23.59 0 013.75.58l1.87.41c2 .44 2.53.57 3.08.27a2 2 0 00.91-1.21 1.85 1.85 0 00-.23-1.58z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M374.8 491.41h7.76v9.82a1 1 0 01-1 1h-5.77a1 1 0 01-1-1v-9.82h.01z",
    className: "mobilityStations_after_svg__cls-91"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 13.34,
    height: 8.24,
    x: 371.97,
    y: 483.45,
    className: "mobilityStations_after_svg__cls-93",
    rx: 2.4
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 12.13,
    height: 6.64,
    x: 372.58,
    y: 484.25,
    fill: "#aec2dd",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.03,
    rx: 2.05
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M378.61 468.83a2.49 2.49 0 012.49 2.49v12.6h-5v-12.6a2.49 2.49 0 012.51-2.49z",
    className: "mobilityStations_after_svg__cls-95"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M346.31 468.83H333a2 2 0 010-4.07h13.28a2 2 0 010 4.07z",
    className: "mobilityStations_after_svg__cls-96"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M346.94 466.69a42.15 42.15 0 009.67.12c4-.43 6.16-1.27 7.85.11 1.51 1.24 1.19 3.05 3.34 4.46a7.68 7.68 0 002.82 1 17.76 17.76 0 006.85.05",
    className: "mobilityStations_after_svg__cls-97"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M411.28 468.83h13.28a2 2 0 000-4.07h-13.28a2 2 0 000 4.07z",
    className: "mobilityStations_after_svg__cls-96"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M410.65 466.69a42.15 42.15 0 01-9.67.12c-4-.43-6.16-1.27-7.85.11-1.51 1.24-1.19 3.05-3.34 4.46a7.68 7.68 0 01-2.82 1 17.76 17.76 0 01-6.85.05",
    className: "mobilityStations_after_svg__cls-97"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 372.64,
    x2: 353,
    y1: 573.07,
    y2: 620.61,
    fill: "#cc4058",
    stroke: "#2c3d4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 235.34,
    y: 555.04,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.87
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.74,
    x: 278.64,
    y: 585.32,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.87
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M284.28 585.41a1.85 1.85 0 01-1.82-1.88l.18-10.11-9.43-.42a1.85 1.85 0 11.16-3.7l11.23.5a1.84 1.84 0 011.77 1.88l-.21 11.91a1.85 1.85 0 01-1.88 1.82zM252.27 573h-.09l-11.23-.5a1.85 1.85 0 01-1.77-1.88l.21-11.91a1.85 1.85 0 011.85-1.82 1.85 1.85 0 011.82 1.89l-.17 10.11 9.43.41a1.85 1.85 0 01-.08 3.7z",
    className: "mobilityStations_after_svg__cls-88"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 256.56,
    y: 569.37,
    className: "mobilityStations_after_svg__cls-74"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 2.08,
    height: 3.63,
    x: 266.99,
    y: 569.37,
    className: "mobilityStations_after_svg__cls-74"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 9.67,
    height: 102.16,
    x: 296,
    y: 519.61,
    className: "mobilityStations_after_svg__cls-90",
    rx: 4.83
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 9.67,
    height: 102.16,
    x: 218.75,
    y: 519.61,
    className: "mobilityStations_after_svg__cls-90",
    rx: 4.83
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 253.86,
    y: 508.47,
    className: "mobilityStations_after_svg__cls-99"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 3.19,
    height: 9.08,
    x: 268.81,
    y: 508.47,
    className: "mobilityStations_after_svg__cls-99"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea384e",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.85,
    d: "M269.11 515.74h-13a3.82 3.82 0 00-3.81 3.81v53.16a2.29 2.29 0 002.29 2.28h0a2.29 2.29 0 002.29-2.28v-53.06a14.79 14.79 0 0111.51-.34v53.4a2.29 2.29 0 004.57 0v-53.16a3.81 3.81 0 00-3.85-3.81z"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 251.78,
    y: 562.98,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.35
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 16.82,
    x: 271.91,
    y: 562.98,
    className: "mobilityStations_after_svg__cls-86",
    rx: 1.35
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M272.92 506.6a1.81 1.81 0 00-1.26-.53 15.33 15.33 0 01-4.13-1.29c-.26-.11-1.39-.58-2.25-1v-2.28h-5.38v2.28c-.87.45-2 .92-2.26 1a15.33 15.33 0 01-4.13 1.29 1.82 1.82 0 00-1.26.53 1.88 1.88 0 00-.21 1.58 2.13 2.13 0 00.91 1.2c.56.31 1.08.18 3.08-.26l1.88-.41a23.65 23.65 0 013.75-.59h1.86a23.65 23.65 0 013.75.59l1.87.41c2 .44 2.53.57 3.08.26a2 2 0 00.91-1.2 1.88 1.88 0 00-.21-1.58z",
    className: "mobilityStations_after_svg__cls-93"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0c100",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M258.71 491.34h7.76v9.82a1 1 0 01-1 1h-5.77a1 1 0 01-1-1v-9.82h.01z"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    width: 13.34,
    height: 8.24,
    x: 255.89,
    y: 483.39,
    className: "mobilityStations_after_svg__cls-93",
    rx: 2.4
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    width: 12.13,
    height: 6.64,
    x: 256.49,
    y: 484.19,
    fill: "#aec2dd",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 2.05
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M262.53 468.76a2.49 2.49 0 012.49 2.49v12.6h-5v-12.6a2.49 2.49 0 012.51-2.49z",
    className: "mobilityStations_after_svg__cls-95"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    width: 63.31,
    height: 87.2,
    x: 230.86,
    y: 503.93,
    fill: "#f0c100",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M230.23 468.76H217a2 2 0 010-4.07h13.28a2 2 0 010 4.07z",
    className: "mobilityStations_after_svg__cls-96"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M230.86 466.63a41.48 41.48 0 009.67.11c4-.42 6.16-1.27 7.85.12 1.51 1.23 1.19 3.05 3.34 4.45a7.33 7.33 0 002.82 1 17.52 17.52 0 006.85.06",
    className: "mobilityStations_after_svg__cls-97"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M295.2 468.76h13.28a2 2 0 000-4.07H295.2a2 2 0 000 4.07z",
    className: "mobilityStations_after_svg__cls-96"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M294.57 466.63a41.48 41.48 0 01-9.67.11c-4-.42-6.16-1.27-7.85.12-1.51 1.23-1.19 3.05-3.34 4.45a7.33 7.33 0 01-2.82 1 17.52 17.52 0 01-6.85.06",
    className: "mobilityStations_after_svg__cls-97"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M239.48 508.05v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 236.72,
    y: 509.06,
    className: "mobilityStations_after_svg__cls-33"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M249.16 508.05v3.78h-3.78v-3.78h3.78m.36-.36H245v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 246.42,
    y: 509.06,
    className: "mobilityStations_after_svg__cls-33"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M239.48 517.73v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 236.72,
    y: 518.75,
    className: "mobilityStations_after_svg__cls-33"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M249.16 517.73v3.78h-3.78v-3.78h3.78m.36-.36H245v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 246.4,
    y: 518.75,
    className: "mobilityStations_after_svg__cls-33"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M244.66 512.55V517h-4.46v-4.46h4.46m.36-.36h-5.18v5.18H245v-5.18z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 241.57,
    y: 513.91,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 241.56,
    y: 517.37,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 241.57,
    y: 510.44,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 238.1,
    y: 513.91,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 245.04,
    y: 513.91,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 236.72,
    y: 515.65,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 236.72,
    y: 512.16,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 246.78,
    y: 515.65,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 246.78,
    y: 512.17,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 239.82,
    y: 519.12,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 243.3,
    y: 519.12,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 239.82,
    y: 508.7,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 243.32,
    y: 508.7,
    className: "mobilityStations_after_svg__cls-33"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M330.75 383.8v10h-10v-10h10m.95-.95h-11.92v11.93h11.92v-11.93z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 323.43,
    y: 386.49,
    className: "mobilityStations_after_svg__cls-33"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M356.43 383.8v10h-10v-10h10m.95-.95h-11.93v11.93h11.93v-11.93z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 349.16,
    y: 386.49,
    className: "mobilityStations_after_svg__cls-33"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M330.75 409.48v10h-10v-10h10m.95-1h-11.92v11.93h11.92v-11.89z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 323.43,
    y: 412.18,
    className: "mobilityStations_after_svg__cls-33"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M356.43 409.48v10h-10v-10h10m.95-1h-11.93v11.93h11.93v-11.89z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 349.1,
    y: 412.18,
    className: "mobilityStations_after_svg__cls-33"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M344.5 395.73v11.84h-11.84v-11.84h11.84m.95-1H331.7v13.74h13.75v-13.69z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 336.3,
    y: 399.35,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 336.27,
    y: 408.52,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 336.3,
    y: 390.15,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 327.09,
    y: 399.35,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 345.49,
    y: 399.34,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 323.43,
    y: 403.96,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 323.43,
    y: 394.71,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 350.12,
    y: 403.96,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 350.12,
    y: 394.72,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 331.65,
    y: 413.15,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 4.62,
    x: 340.89,
    y: 413.15,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 331.66,
    y: 385.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    width: 4.63,
    height: 4.63,
    x: 340.93,
    y: 385.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M533.47 532.16v3.78h-3.78v-3.78h3.78m.36-.36h-4.49v4.49h4.49v-4.49z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 530.71,
    y: 533.17,
    className: "mobilityStations_after_svg__cls-33"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M543.15 532.16v3.78h-3.78v-3.78h3.78m.36-.36H539v4.49h4.49v-4.49z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 540.41,
    y: 533.17,
    className: "mobilityStations_after_svg__cls-33"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M533.47 541.84v3.78h-3.78v-3.78h3.78m.36-.36h-4.49V546h4.49v-4.49z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 530.71,
    y: 542.85,
    className: "mobilityStations_after_svg__cls-33"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M543.15 541.84v3.78h-3.78v-3.78h3.78m.36-.36H539V546h4.49v-4.49z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 540.39,
    y: 542.85,
    className: "mobilityStations_after_svg__cls-33"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M538.66 536.65v4.47h-4.47v-4.47h4.47m.36-.36h-5.19v5.19H539v-5.19z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 535.56,
    y: 538.02,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 535.55,
    y: 541.48,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 535.56,
    y: 534.55,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 532.09,
    y: 538.02,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 539.03,
    y: 538.01,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 530.71,
    y: 539.76,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 530.71,
    y: 536.27,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 540.77,
    y: 539.76,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 540.77,
    y: 536.27,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 533.81,
    y: 543.22,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 537.3,
    y: 543.22,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 533.82,
    y: 532.8,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 537.31,
    y: 532.8,
    className: "mobilityStations_after_svg__cls-33"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M943.8 541.47H751.35l13.27-172.39A20.06 20.06 0 01784.68 349h125.79a20.06 20.06 0 0120.06 20.06z"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    width: 24.16,
    height: 43.15,
    x: 910.29,
    y: 554.63,
    className: "mobilityStations_after_svg__cls-105",
    rx: 5.75
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    width: 24.16,
    height: 43.15,
    x: 760.7,
    y: 554.63,
    className: "mobilityStations_after_svg__cls-105",
    rx: 5.75
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M847.57 354.63h59.33a17 17 0 0117 17v169.8h-76.33v-186.8z",
    className: "mobilityStations_after_svg__cls-106"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M771.2 354.63h76.38v169.8a17 17 0 01-17 17H771.2v-186.8z",
    className: "mobilityStations_after_svg__cls-106",
    transform: "rotate(-180 809.385 448.045)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#343432",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M751.35 541.47H943.8v10.14a16.18 16.18 0 01-16.18 16.18H767.53a16.18 16.18 0 01-16.18-16.18v-10.14h0z"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    width: 159.22,
    height: 15.97,
    x: 768.18,
    y: 541.47,
    fill: "#21211e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M834.2 475.82h-3.38a4.77 4.77 0 00-8.24 0h-6.07a1.95 1.95 0 100 3.89h5.64a4.77 4.77 0 009.1 0h3a1.95 1.95 0 000-3.89zM879.07 475.82H873a4.77 4.77 0 00-8.24 0h-3.38a1.95 1.95 0 000 3.89h3a4.77 4.77 0 009.1 0h5.64a1.95 1.95 0 100-3.89z",
    className: "mobilityStations_after_svg__cls-109"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M763.48 521.33a3.92 3.92 0 003.91-3.91v-37.69a3.92 3.92 0 00-3.91-3.91h-7.08l-3.5 45.51zM931.12 521.33a3.92 3.92 0 01-3.91-3.91v-37.69a3.92 3.92 0 013.91-3.91h7.07l3.5 45.51z",
    className: "mobilityStations_after_svg__cls-110"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    width: 52.64,
    height: 11.22,
    x: 859.22,
    y: 519.46,
    fill: "#e6e6e6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    rx: 5.34
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M884.57 499.12v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 881.81,
    y: 500.13,
    className: "mobilityStations_after_svg__cls-33"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M894.25 499.12v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 891.51,
    y: 500.13,
    className: "mobilityStations_after_svg__cls-33"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M884.57 508.8v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 881.81,
    y: 509.82,
    className: "mobilityStations_after_svg__cls-33"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M894.25 508.8v3.78h-3.78v-3.78h3.78m.36-.36h-4.5v4.5h4.5v-4.5z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 891.49,
    y: 509.82,
    className: "mobilityStations_after_svg__cls-33"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M889.75 503.62v4.46h-4.46v-4.46h4.46m.36-.36h-5.18v5.18h5.18v-5.18z",
    className: "mobilityStations_after_svg__cls-33"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 886.66,
    y: 504.98,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 886.65,
    y: 508.44,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 886.66,
    y: 501.51,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 883.19,
    y: 504.98,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 890.13,
    y: 504.98,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 881.81,
    y: 506.72,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 881.81,
    y: 503.23,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 891.87,
    y: 506.72,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 891.87,
    y: 503.24,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 884.91,
    y: 510.18,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    width: 1.74,
    height: 1.74,
    x: 888.39,
    y: 510.18,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 884.91,
    y: 499.77,
    className: "mobilityStations_after_svg__cls-33"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    width: 1.75,
    height: 1.75,
    x: 888.41,
    y: 499.77,
    className: "mobilityStations_after_svg__cls-33"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilityStationsafter);
export default __webpack_public_path__ + "static/media/mobilityStations.after.95ef346c.svg";
export { ForwardRef as ReactComponent };